import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

const getCurrentLanguage = () => {
  const path = window.location.pathname
  if (path.includes('/esp')) return 'es'
  return 'en'
}

const resources = {
  en: {
    strCommon: {
      confirm: 'confirm',
      of: 'of',
      cancel: 'cancel',
      or: 'or',
    },
    strCommonUI: {
      button: {
        signIn: 'Sign in',
        signOut: 'Sign out',
        userProfile: 'User Profile',
        continue: 'Continue',
        accessAccount: 'Access my account',
        updateInfo: 'Update info',
        completeProfile: 'Complete profile',
        updateDetails: 'Update details',
        updateEmail: 'Update email',
        updatePassword: 'Update password',
        save: 'Save',
        rename: 'Rename',
        delete: 'Delete',
        cancel: 'cancel',
        add: 'add',
        addPlayers: 'Add players',
        invitePlayers: 'Invite players',
        createWatchlist: 'Create watchlist',
        remove: 'remove',
        update: 'update',
        updated: 'updated',
        edit: 'edit',
        back: 'back',
        submit: 'submit',
        confirm: 'confirm',
        postScore: 'post score',
        reject: 'reject',
        accept: 'accept',
        okGotIt: 'Ok, got it',
        singles: 'Singles',
        doubles: 'Doubles',
        subscribe: 'subscribe',
        postAScore: 'Post a score',
        new: 'NEW',
        join: 'join',
        yesDelete: 'yes, delete',
        noCancel: 'no, cancel',
        close: 'close',
        done: 'done',
        clear: 'Clear',
        clearTextField: 'clear text field',
        applyFilter: 'Apply filter',
        exportCsv: 'Export to CSV',
        manage: 'Manage',
        seeError: 'see error details',
        copyToClipboard: 'Copy to clipboard',
        register: 'Sign up',
        subscribeToNewsletter: 'Subscribe to our newsletter',
      },
      link: {
        here: 'here',
        clickHere: 'Click here',
        back: 'Back',
        backTo: 'Back to {{name}}',
        myProfile: 'My profile',
        myAccount: 'My account',
        news: 'News',
        myWatchlists: 'My watchlists',
        goToWatchlists: 'Go to My watchlists',
      },
      select: {
        pleaseChoose: 'Please choose...',
      },
      form: {
        allFieldsMandatory: 'All fields are mandatory unless otherwise stated.',
        required: 'is required',
        invalid: 'is invalid',
        consent: 'Consent',
        firstName: 'Given name',
        lastName: 'Family name',
        dob: 'Date of birth',
        inputDayPlaceholder: 'dd',
        inputMonthPlaceholder: 'mm',
        inputYearPlaceholder: 'yyyy',
        sex: 'Sex',
        sexMale: 'Male',
        sexFemale: 'Female',
        nationality: 'Nationality',
        residence: 'Country of residence',
        email: 'Email',
        password: 'password',
        watchlistName: 'watchlist name',
        parentGuardianName: 'Parent or guardian full name',
        parentGuardianEmail: 'Parent or guardian email',
        personaSelect: 'What best describes your tennis involvement?',
        pleaseSpecify: 'Please specify',
        charsRemaining: '{{ count }} characters remaining',
        whereDidYouHearAboutUs: 'Where did you hear about us? (Optional)',
        whereDidYouHearAboutUsSelect: 'Where did you hear about us? (Optional)',
        validationErrors: {
          minMaxChars: 'must be between {{minLength}} and {{maxLength}} characters long',
          maxChars: '{{name}} must be less than {{maxLength}} characters long',
          maxCharsExceeded: 'Max number of characters exceeded',
          dobInThePast: 'Date of birth must be a past date',
          minAge: 'Minimum age is {{minAge}}',
          maxAge: 'Maximum age is {{maxAge}}',
          minAgeToRegister: 'You must be at least {{minAge}} to register for WTN',
          minAgeForService: 'You must be at least {{minAge}} to use WTN',
          minHeight: 'Min allowed height is: {{minHeightMetric}} ({{minHeightImperial}})',
          maxHeight: 'Max allowed height is: {{maxHeightMetric}} ({{maxHeightImperial}})',
          onlyAlphanumeric: 'Only alphanumeric values are allowed',
          watchlistNameRequired: 'Please add a name for the watchlist',
          watchlistNameExists: 'You already have a watchlist with this name',
          invalidValue: 'Invalid value',
        },
      },
      placeholder: {
        searchResidence: 'Type residence...',
        searchNationality: 'Type nationality...',
        personaDetails: 'Enter a role...',
        whereHeardDetails: 'Enter where you heard about us...',
        searchNA: 'Type National Assocation...',
        searchNationalAssociation: 'Type National Association...',
      },
      ariaLabel: {
        accountMenu: 'Account Menu',
        pendingMatchMenu: 'Social match options menu',
        moreInfo: 'More info',
        moreOptions: 'More options',
        noRating: 'No rating available',
        watchlistIncludedBtn: 'Player included in Watchlist, click to remove player',
        watchlistNotIncludedBtn: 'Player not included in Watchlist, click to add player',
        loading: 'Loading',
        noData: 'No data available',
        joinWtn: 'Join WTN',
        mobileNavigation: 'Mobile navigation',
        mainNavigation: 'Main navigation',
      },
      badge: {
        new: 'NEW',
      },
      menu: 'Menu',
      userProfile: 'User',
      selectLanguage: 'Select language',
      availableLanguages: 'Available languages',
      text: {
        daysCount: '{{count}} day',
        daysCount_plural: '{{count}} days',
      },
    },
    strData: {
      noPlayerName: 'Unknown Player',
      unknown: 'Unknown',
      optOutPlayerName: 'Player',
      na: 'N/A',
      pro: 'PRO',
      male: 'Male',
      female: 'Female',
      unspecified: 'Unspecified',
      ellipsis: '...',
      single: 'Single',
      double: 'Double',
      left: 'Left handed',
      right: 'Right handed',
      ambidextrous: 'Ambidextrous',
    },
    strPlayerLevel: {
      title: 'Player level',
      topPercentile: 'Top {{percentile}}%',
      topPercentileNoValue: 'N/A',
      verifiedText:
        'These statistics only include players with a <button>verified Singles WTN</button> (<span />).',
      unverifiedText:
        'These statistics only show for players with a <button>verified Singles WTN</button> (<span />). <br/>More match results are required to ensure accuracy.',

      modal: {
        title: 'Player levels',
        description:
          'The Player Level feature offers verified players deeper insight into their WTN and how they compare to similar players.',
        verifiedOnly: 'This feature is only available to verified players.',
        sex: {
          title: 'Sex:',
          description:
            'The player is compared to verified players who share the same recorded sex.',
        },
        nationality: {
          title: 'Nationality:',
          description:
            'The player is compared to verified players who share the same recorded nationality.',
        },
        ageGroup: {
          title: 'Age Group:',
          description: 'The player is compared to verified players within the same age range.',
        },
        percentile: {
          title: 'Percentile:',
          description: 'The player ranks within the top % of verified players in this group.',
        },
        close: 'Close',
      },

      attribute: {
        Age: {
          '0-12': 'Under 12',
          '13-14': 'Age 13-14',
          '15-16': 'Age 15-16',
          '17-18': 'Age 17-18',
          '19-30': 'Age 19-30',
          '31-40': 'Age 31-40',
          '41-50': 'Age 41-50',
          '51-60': 'Age 51-60',
          '60+': 'Age 60+',
          Unknown: 'Age unknown',
        },
        Sex: {
          M: 'Men',
          F: 'Women',
          U: 'Others',
        },
      },
    },
    strPlayerStats: {
      matchActivityTitle: 'Match activity',
      daysSinceLastMatchTitle: 'Days since last match:',
      uniqueSinglesTitle: 'Unique singles opponents:',
      singlesIntervalTitle: 'Average singles interval:',
      doublesIntervalTitle: 'Average doubles interval:',
      ratingHighsAndLows: 'Rating range',
      lowestTitle: 'Lowest',
      highestTitle: 'Highest',
      pastYeartitle: 'Past Year',
      allTimeTitle: 'All Time',
      singles: 'Singles',
      doubles: 'Doubles',
      days: 'days',
    },
    strSearchBar: {
      placeholderDefault: 'Search',
      placeholder: 'Type surname or Tennis ID...',
      viewAll: 'See all {{type}}',
      notFound: 'No {{type}} found',
      player: 'player',
      players: 'players',
      vs: 'VS',
      h2hSearchCompare: 'Choose players to compare in the boxes above',
      h2hSingleSearchCompare: 'Choose a player to compare in the box above',
    },
    strFilterBar: {
      genderDefaultLabel: 'Any Gender',
      male: 'Male',
      female: 'Female',
      anyGender: 'Gender',
      anyGenderOption: 'Any gender',
      nonBinary: 'Non-Binary',
      anyAgeGroup: 'Age group',
      ageGroupCompositeDropdownLabel: 'Age: {{ageGroup}}',
      ageGroupBornInLabel: 'Born {{birthYear}}',
      countries: 'Countries',
      yes: 'yes',
      no: 'no',
      filterBy: 'Filter by',
      countryDefaultLabel: 'Nationality',
      nationalityCompositeDropdownLabel: 'Nationality: +{{numberSelected}}',
      clearFilter: 'Clear filter',
      countryFilterPlaceholder: 'Type to filter...',
      rating: {
        radioAllPlayers: 'All players',
        radioRatingRange: 'Rating range',
        labelDropdownCombined: 'WTN Rating',
        labelRatingType: 'Rating type',
        labelConfidenceLevel: 'Confidence level',
        defaultLabelSingles: 'Singles number',
        defaultLabelDoubles: 'Doubles number',
        radioSingles: 'Singles',
        radioDoubles: 'Doubles',
        radioConfidenceHigh: 'High confidence (verified)',
        radioConfidenceAll: 'All',
        compositeDropdownLabel: '{{appliedLabel}}: {{min}}-{{max}}',
        inputError: 'Allowed values are between {{max}} and {{min}} with only one decimal.',
        confidenceModal: {
          title: 'Number Verification',
          tickHigh: 'Blue confidence ribbon',
          tickLow: 'Grey confidence ribbon',
          exampleNumber: 'Example number',
        },
      },
      wtnRange: 'WTN Range',
      apply: 'APPLY FILTER',
      cancel: 'CANCEL',
      rangeLabel: '{{range}} Rating',
      rangeLabelSingles: 'Singles number',
      rangeLabelDoubles: 'Doubles number',
      clearFilters: 'Clear filters',
      filters: 'Filters',
      minRating: 'Min rating',
      maxRating: 'Max rating',
    },
    searchResults: {
      wtn: 'WTN',
      searching: 'Searching for results...',
      tableResultsInfo: 'Showing {{showing}} of 1000s of results',
      tableResultsInfoWithTotal: 'Showing {{showing}} of {{total}} results',
      nationalityHeading: 'Nationality',
      ageGroupHeading: 'Age group',
      playersHeading: 'Players',
      singlesHeading: 'Singles number',
      doublesHeading: 'Doubles number',
      age: 'Age',
      loadMore: 'LOAD MORE',
      showMore: 'SHOW MORE',
      noPlayers: 'No players found. Please input a player name, before applying the filters',
      modalHeader: 'Head to head results',
    },
    strCharts: {
      singles: 'Singles',
      doubles: 'Doubles',
      both: 'Both',
      wins: 'Wins',
      losses: 'Losses',
      winLossRecordsKey: ['Wins', 'Losses', 'Walkovers', 'Retirements'],
      wtnHistory: 'WTN History',
      singlesWinLoss: 'Singles win-loss record',
      doublesWinLoss: 'Doubles win-loss record',
      bothWinLoss: 'Singles and Doubles win-loss record',
      errorFetchingData: 'There has been an error fetching the data. Please retry later.',
      noData: 'No results available for the selected date range',
      noDataShort: 'No results available',
      noDataGeneric: 'Sorry, there is no data available',
      noDataTournaments: 'Sorry, there is no data available. Please select another year',
    },
    strDateFilter: {
      allTime: 'All time',
      oneMonth: 'Last Month',
      nMonths: 'Last {{months}} months',
      nYears: 'Last {{years}} years',
    },
    strMobileFilter: {
      filters: 'Filters',
      filtersWithCount: 'Filters ({{count}})',
      filtersAndSort: 'Filters and Sort',
      filtersAndSortWithCount: 'Filters and Sort ({{count}})',
      gameType: 'Game type',
      year: 'year',
      reset: 'Reset',
      clearAll: 'Clear all',
      gender: 'Gender',
      ageGroup: 'Age group',
      anyAgeGroupOption: 'Any age group',
      nationality: 'Nationality',
      anyNationality: 'Any nationality',
      rating: 'WTN Rating',
      anyRating: 'All players',
      sortBy: 'Sort by',
      sortingLabelSingles: 'Singles number',
      sortingLabelDoubles: 'Doubles number',
      sortingLabelName: 'Player name',
      cancel: 'Cancel',
      goBack: 'Back',
      updateFilters: 'Apply Filters',
      timePeriod: 'Time period',
    },
    strProfileHeader: {
      age: 'Age',
      bornIn: 'Born in',
      under: 'Under',
      editProfile: 'Edit profile',
      addToWatchlist: 'Add to watchlist',
      removeFromWatchlist: 'Remove from watchlist',
      singlesWtn: 'Singles WTN',
      doublesWtn: 'Doubles WTN',
      WTNDefinition:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      additionalInfo: 'Player details',
      residence: 'Residence',
      eventsPlayed: 'Events played',
      preferredHand: 'Preferred hand',
      height: 'Height',
      favouriteShot: 'Favourite shot',
      backhand: 'Backhand',
      clubsAssociations: 'Clubs & associations',
    },
    strGuidedTour: {
      overview: {
        title: 'Overview',
        content:
          'Find your real-time ITF World Tennis Number, Game zOne, match statistics and your rating history.',
      },
      results: {
        title: 'Results',
        content:
          'See all the match results we have for you. You can filter months, days and years.',
      },
      headToHead: {
        title: 'Head-to-Head',
        content:
          'Search and compare yourself with other players in the ITF World Tennis Number community.',
      },
      yourNumber: {
        title: 'Your number',
        content:
          'Compare Numbers with others, look at your match history and competitors in common.',
      },
      watchlist: {
        title: 'Watchlist',
        content: 'Keep a track of your favourite players, friends, colleagues, and family.',
      },
      competitions: {
        title: 'Competitions',
        content:
          "<0>Under the 'Competitions' feature, all competition match results that have been submitted by a National or Regional Association, or the ITF, will be shown here.</0><1>Visit your profile to view your competition match results.</1><2>Note that players will be unable to submit tournament match results here.</2>",
        contentOwnProfile:
          '<0>All competition match results that have been submitted by your National or Regional Association, or the ITF, will appear in this tab.</0><1>Note that you will not be able to submit scores here.</1>',
      },
      myMatches: {
        title: 'My Matches',
        content:
          '<0><0>NEW!</0> Players can now post scores for the matches played outside of tournaments.</0><1>Visit your profile to begin posting scores.</1><2>Note that players will only be able to submit a result against an opponent who holds an <1>ITF World Tennis Number</1> account, however this does exclude IPIN Juniors and Professionals.</2>',
        contentOwnProfile:
          '<0><0>NEW!</0> You can now post scores for the matches you played outside of tournaments.</0><1>Note that you will only be able to submit a result against a player who holds an <2>ITF World Tennis Number</2> account, however this does exclude IPIN Juniors and Professionals.</1>',
      },
    },
    strScaleModal: {
      aboutWTNHeader: 'About World Tennis Number',
      okGotItButton: 'OK, GOT IT',
      aboutWTNContent:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam minima tenetur nisi obcaecati nihil aliquam dolor accusantium nemo eum rem, quis, non molestiae eos possimus praesentium pariatur, provident doloribus nostrum.',
    },
    strProfile: {
      sections: {
        overview: 'overview',
        results: 'results',
        h2h: 'head-to-head',
        competitions: 'competitions',
        socialMatches: 'my matches',
      },
      overview: 'Overview',
      playerStats: 'Player Stats',
      comparePlayers: 'Compare players',
      headToHead: 'Head to Head',
      wtnHistory: 'World Tennis Number history',
      playerTournMatches: 'Player tournament matches',
      resultsSummary: 'Results summary',
      h2hSearchDescription: 'Select players to compare <2>{{name}}</2> to',
      pageNotFound: 'The page you requested cannot be found.',
      invalidPlayerId: 'This player ID is invalid',
      error: 'Error',
      defaultErrorMsg: 'Something went wrong...',
      problemLoadingProfile: 'Encountered an error while loading this players profile. ',
      navigateBack: 'Please navigate back to the',
      homepage: 'homepage',
      notFound: 'Player Not Found',
      selectAnotherPage: 'or select another page from the navigation menu.',
      modals: {
        info: {
          competitions:
            "<0>Under the 'Competitions' feature, all competition match results that have been submitted by your National or Regional Association, or the ITF, will be shown here.</0><1>Note that you will be unable to submit tournament match results here.</1>",
          myMatches:
            "<0>Under the 'My Matches' feature, you can now post scores for the matches you played outside of tournaments.</0><2>Note that you will only be able to submit a result against a player who holds an <1>ITF World Tennis Number</1> account, however this does exclude IPIN Juniors and Professionals.</2><4>Once a score is submitted, your opponent will be sent an email asking for them to confirm the match result(s). If there is not a response within 72 hours, this will be automatically verified.</4>",
        },
      },
    },
    strMessageScreen: {
      recaptchaValidationErrorInfo:
        'reCAPTCHA could not determine with certainty that the form was submitted by a human. Please refresh this page and try again. If the issue persists <2>contact us</2>',
      featureNotAvailableReadFaqs:
        '<0>You may be ineligible for this feature. Please read our <2>FAQs</2>.</0>',
      lockedFeature: {
        logInOrSignUp: '<0><0>Log in</0> or <2>Sign up</2> for an account.</0>',
        blurredResults: 'To view results, you will need to be logged in',
        blurredMatchHistory: 'To view match history, you will need to be logged in',
        blurredWtnHistory: 'To view history, you will need to be logged in',
        blurredPlayerLevels: 'To view player levels, you will need to be logged in',
      },
      backToHome: 'Back to home page',
      pageNotFound: 'Page not found',
      pageNotFoundInfo: 'The page you requested cannot be found',
      pageRestricted: 'Sign in required',
      pageRestrictedInfo: 'Please sign in to see this page',
      signOutRequired: 'Sign out required',
      signOutRequiredInfo: 'Please sign out to see this page',
      playerNotFound: 'Player not found',
      playerNotFoundInfo:
        'The player ID could not be found. The link you followed may be broken, or the page may have been removed.',
      ownProfileError: 'Error loading profile',
      ownProfileErrorInfo: 'An error occurred while retrieving your profile details',
      ownProfileErrorLink: 'Please refresh or try again later',
      appError: 'Something went wrong',
      appErrorInfo: 'An error occurred while processing your request',
      appErrorLink: 'Please refresh or try again later',
      somethingWrong: 'Something went wrong',
      somethingWrongInfo:
        'Please navigate back to the homepage or select another page from the navigation menu',
      alreadyRegistered: 'Account already registered',
      alreadyRegisteredLink: 'Go to sign in',
      activationError: 'Activation error',
      activationErrorInfo: 'An error occurred while activating your account',
      activationErrorLink: 'Click here to contact us',
      activationLoginPrompt: 'Sign in required',
      activationLoginPromptInfo:
        'Please sign in with your credentials to complete account activation',
      signInLink: 'Go to sign in',
      signOutLink: 'Sign me out',
      fastTrackError: 'Something went wrong',
      fastTrackErrorInfo: 'An error occurred while retrieving or updating your details',
      fastTrackErrorLink: 'Click here to contact us',
      recaptchaValidationError: 'Failed reCAPTCHA validation',
      recaptchaValidationErrorLink: 'Refresh page',
      inviteRequired: 'Invite required',
      inviteRequiredInfo:
        'Sorry, you currently need to have an invitation to sign-up to ITF World Tennis Number',
      inviteRequiredLink: 'Back to home page',
      psqUnableSubmit: "Unable to submit 'Rate My Game' questionnaire",
      psqUnableSubmitInfo:
        "You cannot submit a 'Rate My Game' questionnaire as you already have an ITF World Tennis Number",
      psqUnableSubmitLink: 'Back to my profile',
      psqNotEligibleInfo:
        "The 'Rate My Game' feature is currently unavailable in your country of residence",
      psqUnableSubmitMinAge:
        "You need to be at least {{minAge}} to submit a 'Rate My Game' questionnaire",
      psqSubmitError: "Error submitting 'Rate My Game' questionnaire",
      psqSubmitErrorInfo:
        "There was an error while submitting your 'Rate My Game' questionnaire. Please try again later.",
      psqSubmitErrorLink: 'Back to my profile',
      featureNotAvailable: 'Feature not available',
      featureNotAvailableProAndJuniors:
        'This feature is not available for players with an active junior or professional IPIN.',
      errorInfo: {
        intro: 'Message:',
        location: 'Location:',
        rlog: 'RLOG:',
      },
    },
    strMatchHistory: {
      matchHistory: 'Match history',
      noMatchHistory: 'No match history found',
      date: 'Date',
      tournament: 'Tournament',
      draw: 'Draw',
      winner: 'Winner',
      score: 'Score',
      headToHead: 'Head-to-Head',
      percentageWins: '% wins',
      wtn: 'WTN',
      time: 'time',
      times: 'times',
      notCompeted: 'These players have not competed',
      close: 'Close',
    },
    strH2H: {
      age: 'Age',
      yearOfBirth: 'Birth Year',
      gender: 'Gender',
      nationality: 'Nationality',
      wtnSingles: 'SINGLES NUMBER',
      wtnDoubles: 'DOUBLES NUMBER',
      wins: 'Win',
      wins_plural: 'Wins',
      winsWithCount: '{{count}} win',
      winsWithCount_plural: '{{count}} wins',
      winLikelihood: {
        singlesLabel: 'SINGLES WIN LIKELIHOOD',
        doublesLabel: 'DOUBLES WIN LIKELIHOOD',
        score: {
          over: 'Over {{score}}%',
          under: 'Under {{score}}%',
          exact: '{{score}}%',
        },
        unavailable: 'Prediction unavailable',
        lowConfidence:
          '<0>Both players must have verified World Tennis Numbers for an accurate prediction to display.</0> <2>Understanding verification</2>',
      },
      totalWins: 'Total wins',
      loginToView: '<0>Log in</0> to view',
    },
    strMatchResults: {
      matchResults: 'match results',
      competitions: {
        title: 'Competition results',
        modal: {
          header: 'Competitions',
        },
      },
      social: {
        title: 'My match results',
        modal: {
          header: 'My Matches',
        },
      },
      dateRound: 'Date',
      players: 'players',
      score: 'score',
      noResults: { title: 'No results found', info: "Sorry, we couldn't seem to get any results." },
      openAllResults: 'Open all results',
      closeAllResults: 'Close all results',
    },
    strCommonCompetitors: {
      commonCompetitors: 'Competitors in common',
      player: 'Player',
      winLoss: 'W / L',
      winPercent: 'WIN %',
      totals: 'TOTAL',
      noCommonCompetitors: 'These players have no common competitors during this period',
      showMore: 'Show more',
    },
    strRecentOpponents: {
      header: 'Recent opponents',
      thisPlayer: 'this player',
      sortBy: 'Sort by:',
      date: 'Date',
      opponent: 'Opponent',
      winLoss: 'W-L',
      w: 'W',
      l: 'L',
      score: 'Score',
      winLossRecord: 'W/L record',
    },
    strDates: {
      monthsShort: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ],
      monthsLong: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    },
    strMyAccount: {
      myDetails: 'My details',
      changePassword: 'Change password',
      signInDetails: {
        title: 'Sign in details',
        subtitle: "Below you'll be able to update your sign in details.",
        bodyTitle: 'Update details',
      },
      accountUpToDate: 'Please keep your account details up to date.',
      avatar: 'Avatar',
      editAvatar: 'Edit avatar',
      uploadPhotoText: 'You can pick an ITF avatar.',
      tennisId: 'Tennis ID',
      playerProfile: 'Player profile',
      infoText: 'If you would like to update your details, please',
      infoError:
        'Sorry, an error occurred while retrieving your details. Please refresh or try again later.',
      contactUs: 'contact us',
      playerInfo: 'Player info',
      profileStrength: 'Profile Strength',
      strProfileStrength: {
        wtn: 'Get your WTN',
        avatar: 'Add an avatar',
        residence: 'Add residence',
        playerInfo: 'Complete player info',
        postMatch: 'Post a match result',
        haveResult: 'Have a match result',
      },
      completionPercentage: '{{count}}% complete',
      completeProfile: 'Complete profile',
      privacyAndConsents: {
        title: 'Privacy & consents',
        subtitle: 'Choose who can see you and manage your communication preferences.',
        bodyTitle: 'Your preferences',
        form: {
          profileVisibility: {
            alert:
              'To fully enjoy your World Tennis Number experience set your profile visibility to "Public". Your player profile will not be searchable and your name will not be shown in match results.',
            label: 'Set your profile visibility',
            optionPublic: 'Public (recommended)',
            optionPrivate: 'Private',
          },
        },
      },
      logout: 'Logout',
    },
    strEditProfile: {
      editProfile: 'Edit Profile',
      profile: 'Profile',
      playerInfo: 'Player info',
      clubsAssociations: 'Clubs & associations',
      inputFirstName: 'First name',
      inputLastName: 'Last name',
      inputNickName: 'Nickname',
      inputNickNamePlaceholder: 'Enter Nickname',
      inputNationality: 'Nationality',
      inputDoB: 'Date of birth',
      inputDayPlaceholder: 'DD',
      inputMonthPlaceholder: 'MMM',
      inputYearPlaceholder: 'YYYY',
      inputSex: 'Sex',
      inputFemale: 'Female',
      inputMale: 'Male',
      inputGender: 'Gender',
      inputResidence: 'Country of residence',
      inputResidencePlaceholder: 'Search...',
      inputHeight: 'Height',
      inputHeightPlaceholder: '75cm - 225cm',
      inputMetric: 'Metric',
      inputImperial: 'Imperial',
      inputPreferredHand: 'Preferred hand',
      optsPreferredHandRight: 'Right',
      optsPreferredHandLeft: 'Left',
      inputBackhand: 'Backhand',
      optsBackhandSingle: 'Single',
      optsBackhandTwo: 'Two handed',
      inputFavouriteShot: 'Favourite shot',
      inputFavouriteShotPlaceholder: 'Please choose...',
      optsFavouriteShotForehand: 'Forehand',
      optsFavouriteShotBackhand: 'Backhand',
      optsFavouriteShotServe: 'Serve',
      optsFavouriteShotVolley: 'Volley',
      optsFavouriteShotSmash: 'Smash',
      optsFavouriteShotDropShot: 'Drop shot',
      dropdownPlaceholder: '-- select an option --',
      update: 'Update',
    },
    strSelectAvatar: {
      selectAvatar: 'Select avatar',
      chooseAvatar: 'Choose an avatar',
      chooseStyle: 'Choose a style',
      uploadPhoto: 'Upload photo',
      pickItfAvatar: 'pick ITF avatar',
      cancel: 'CANCEL',
      setAsMyAvatar: 'Set as my Avatar',
    },
    strUploadImage: {
      fileUploadText: 'Max file size of 4 MB. JPG or PNG',
      fileSizeError: {
        1: "Sorry, the image you're trying to upload is larger than 4 MB.",
        2: 'Please reduce the size and try again.',
      },
      fileTypeError: {
        1: "Sorry, the format of the image you're trying to upload is not supported.",
        2: 'The supported formats are JPG and PNG.',
      },
      buttonText: 'Upload file',
      uploadFromDevice: 'Upload from your device',
      changePhoto: 'Change photo',
      dragAndDropHere: 'Drag and drop your image here',
      dragAndDropBelow: 'Drag and drop your image below',
      or: 'or',
      update: 'update',
      remove: 'remove',
      uploadAnotherPhoto: 'Upload another photo',
      dragToReposition: 'Drag to reposition and size your photo',
    },
    strRegister: {
      header: 'Welcome',
      subheader: 'Create your account',
      commConsentItf:
        'Yes, I would like to receive news, information, and special offers from the ITF',
      commConsentNa:
        'Yes, I would like to receive emails from my National Association for marketing purposes',
      intro:
        'Create your ITF Tennis ID user account to gain access to the <2>ITF World Tennis Number</2>.',
      introAlreadyCustomer: {
        1: "It looks like you already have an ITF Tennis ID user account with one of the ITF's other online services such as IPIN or ITF Academy.",
        2: 'Please press CONTINUE to sign in using your existing ITF account email and password to complete your registration for <1>ITF World Tennis Number</1>.',
      },
      infoBoxOne: 'Not {{firstName}} {{lastName}}?<1/><2>Click here</2> for what to do next',
      infoBoxTwo: 'Are your details incorrect? If so, please click <2>here</2>',
      recaptchaDisclaimer:
        'This site is protected by reCAPTCHA and the Google <2>Privacy Policy</2> and <6>Terms of Service</6> apply.',
      agreeTermsWelcome:
        'By creating an account, you agree to <2>ITF Privacy Policy</2> and <6>ITF World Tennis Number Terms & Conditions</6>',
      agreeTermsWelcomeParent:
        'By creating an account, your Parent/Guardian agrees to <2>ITF Privacy Policy</2> and <6>ITF World Tennis Number Terms & Conditions</6>',
      agreeTermsWelcomeYouAndParent:
        'By creating an account, you and/or your Parent/Guardian agree to <2>ITF Privacy Policy</2> and <6>ITF World Tennis Number Terms & Conditions</6>',
      agreeTermsActivation:
        'By activating your account, you agree to <2>ITF Privacy Policy</2> and <6>ITF World Tennis Number Terms & Conditions</6>',
      invalidResidence: {
        GBR: "Currently we're unable to register players who reside in the UK. The good news is that you are still able to find out your ITF World Tennis Number by registering or logging into your profile on the <2>LTA website</2><3/>*Please select 'Ireland' for your country of residence if you reside in Northern Ireland. This is due to Tennis Ireland's province structure.",
        FRA: "Currently we're unable to register players who reside in France. For more information on tennis in France please click <2>here</2>.<4/>Bonjour, a l'heure actuelle l'enregistrement en ligne en France n'est pas disponible. Pour plus d'informations, veuillez visiter le site de la <7>Federation francaise du tennis</7>.",
        USA: "Players residing in the USA can create and unlock their World Tennis Number account by clicking the <1>'CREATE WTN PROFILE'</1> link on their <4>USTA profile</4>",
      },
      whereDidYouHear: {
        NA: 'National Association (including ITF)',
        TENNIS_CLUB: 'Tennis Club',
        TENNIS_TOURNAMENT: 'Tennis Tournament',
        WORD_OF_MOUTH: 'Word of mouth',
        SOCIAL_MEDIA: 'Social media',
        SEARCH_ENGINE: 'Search engine',
        BLOG_OR_PUBLICATION: 'Blog or publication',
        OTHER: 'Other',
      },
      personas: {
        CASUAL_PLAY: 'I play casually with friends and family',
        COMPETITIVE_PLAY: 'I play competitively in tournaments and leagues',
        INTEREST_ONLY: "I don't play but I have an interest in tennis",
        COACH: 'I coach tennis',
        PARENT_OR_CARER: 'I am a parent/carer of a Juniors player',
        OTHER: 'Other',
      },
      comingSoon: {
        title: 'Registration will be available soon',
      },
      parentalConsent: {
        fastTrack: {
          title: 'Parent/Guardian',
        },
        infoBox: {
          title: 'Under 18 registrations',
          info: "If you are under 18 years of age you must ask your parents or legal guardian's consent before you register for an account on worldtennisnumber.com.",
        },
        helpText: 'Please provide the name and email address of your parent or legal guardian.',
      },
      residenceValidationError:
        'Something went wrong fetching country of residence data. Please try again.',
    },
    strFastTrackRegistration: {
      accountCreated: 'Your account has been created!',
      welcome: 'Welcome',
      features: {
        one: 'Match activity',
        two: 'Personalised GameZone',
        three: 'ITF World Tennis Number history',
      },
      checkDetails: "Please check your details below to make sure they're correct",
      residenceTooltip: {
        partOne:
          'Knowing your country of residence enable us to support your queries and improve your experience.',
        partTwo:
          'If you reside in several countries, please choose the one where you play tennis tournaments more often.',
      },
      residenceInfoQuestion: 'What if I reside in several countries?',
    },
    strAlerts: {
      updatingDetails: 'Updating details...',
      detailsUpdated: 'Details successfully updated',
      detailsNotUpdated: 'Error updating details',
      avatarNotUploaded: 'Error uploading avatar image',
      actionError: 'Error trying to perform the requested action. Please try again later.',
      removingPlayerWl: 'Removing player from watchlist(s)...',
      playerWlRemoved: 'Removed player from watchlist(s) successfully',
      errorRemovingPlayerWl: 'Error removing player from watchlist(s)',
      addingPlayerWl: 'Adding player to watchlist(s)...',
      playerWlAdded: 'Player added to watchlist(s) successfully',
      errorAddingPlayerWl: 'Error adding player to watchlist(s)',
      managingPlayerWl: {
        success: {
          add: "Added to '{{name}}'",
          addPlural: 'Added to {{count}} watchlists',
          remove: "Removed from '{{name}}'",
          removePlural: 'Removed from {{count}} watchlists',
          create: "'{{name}}' created",
          update: "'{{name}}' updated",
          updatePlural: '{{count}} watchlists updated',
        },
        error: {
          add: "Error adding to '{{name}}'",
          addFull: "<1>Player can't be added</1><2/>'{{name}}' is full",
          addPlural: 'Error adding to {{count}} watchlists',
          addPluralFull: "<1>Player can't be added</1><2/>{{count}} watchlists are full",
          remove: "Error removing from '{{name}}'",
          removePlural: 'Error removing from {{count}} watchlists',
          create: "Error creating '{{name}}'",
          createFull: "Watchlists limit reached: Could not create '{{name}}'",
        },
      },
      creatingWl: 'Creating watchlist...',
      wlCreated: 'Watchlist successfully created',
      errorCreatingWl: 'Error while trying to create watchlist',
      deletingWl: 'Deleting watchlist...',
      wlDeleted: 'Watchlist successfully deleted',
      errorDeletingWl: 'Error while trying to delete watchlist',
      renamingWl: 'Renaming watchlist...',
      wlRenamed: 'Watchlist successfully renamed',
      errorRenamingWl: 'Error while trying to rename watchlist',
      approvingSocialMatch: 'Accepting your score...',
      errorApprovingSocialMatch: 'Error while accepting your score',
      socialMatchApproved: 'Score successfully accepted',
      rejectingSocialMatch: 'Rejecting your score...',
      errorRejectingSocialMatch: 'Error while rejecting your score',
      socialMatchRejected: 'Score successfully rejected',
      errorSubmittingSocialMatch: 'Error while submitting your score',
      deletingSocialMatch: 'Deleting your score...',
      errorDeletingSocialMatch: 'Error while deleting your score',
      socialMatchDeleted: 'Score successfully deleted',
      socialMatchAlreadyDeleted: 'It looks like this match has been deleted by the user',
      socialMatchAlreadyApproved: 'It looks like this match has already been approved by the user',
      copiedToClipboard: 'Copied to clipboard!',
      failedCopyingToClipboard: 'Failed to copy to clipboard',
      errorPlayerSearch: 'Error while searching for players',
      csvDownload: {
        success: 'CSV download successful',
        error: 'CSV download error',
      },
    },
    strWatchlists: {
      overview: {
        title: 'My watchlists',
        subtitle: '{{count}}/{{max}} watchlists created',
        panelEmpty: {
          title: 'No watchlists yet',
          info: 'Search for a player and use the star icon to add them to a watchlist.',
          button: 'Start searching',
        },
        card: {
          count: '{{count}}/{{max}} players',
        },
        createBtn: 'Create new watchlist',
      },
      detail: {
        count: '{{count}}/{{max}} players',
        panelEmpty: {
          title: 'Your watchlist is empty',
        },
        addBtn: 'Add players',
      },
      addOrManageModal: {
        add: {
          title: 'Add to watchlist',
          watchlistFull: '(watchlist is full)',
          info: 'Add <1>{{name}}</1> to:',
        },
        manage: {
          title: 'Select a watchlist',
          info: 'Assign or remove <1>{{name}}</1> to/from:',
        },
        create: {
          label: 'Create new watchlist',
          charsCount: '{{count}}/{{max}} characters',
          limitReached:
            "You can't create new watchlists because you reached the limit ({{count}}/{{max}}).",
        },
      },
      createModal: {
        title: 'Create a watchlist',
        titleFull: 'Watchlists limit reached',
        defaultLabel: 'Watchlist name',
        info: 'Use watchlists to save players for later.',
        infoFull: 'You cannot create any more watchlists. Please remove one first.',
      },
      renameModal: {
        title: 'Rename watchlist',
        info: 'Choose a different name below to rename the watchlist.',
      },
      deleteModal: {
        title: 'Delete watchlist',
        info: 'Choose a different name below to rename the watchlist.',
      },
      common: {
        averageSinglesWtn: 'Average Singles WTN: {{average}}',
        minSinglesWtn: 'Min. Singles WTN: {{min}}',
        maxSinglesWtn: 'Max. Singles WTN: {{max}}',
      },
      watchlists: 'watchlists',
      watchlist: 'Watchlist',
      name: 'Watchlist name',
      firstName: 'First Name',
      lastName: 'Surname',
      save: 'Save',
      cancel: 'Cancel',
      noCancel: 'No, Cancel',
      yesDelete: 'Yes, Delete',
      playerWatchlistsTitle: 'Select watchlist(s)',
      defaultWatchlist: 'My watchlist',
      update: 'Update',
      add: 'Add',
      delete: 'Delete',
      rename: 'Rename',
      new: 'Create new',
      players: 'Players',
      gender: 'Gender',
      nationality: 'Nationality',
      singles: 'Singles',
      doubles: 'Doubles',
      noPlayers: 'No players in watchlist',
      deleteWatchlist: 'Delete watchlist',
      deleteWatchlistAlertStart: 'Are you sure you want to delete permanently',
      deleteWatchlistAlertEnd: 'watchlist together with players in that watchlist?',
      deletePlayerAlert: 'Are you sure you want to delete the selected player(s)?',
      limit: 'A maximum of 5 watchlists can be created.',
      watchlistOverview: {
        intro: 'You can create up to <1>{{maxWatchlists}} watchlists.</1>',
        rulesIntro: 'Each watchlist can have:',
        rule1: 'Up to <1>{{maxPlayers}} players</1>',
        rule2: 'A <1>name at your choice</1>',
        featuresIntro: "You'll be able to",
        feature1: 'Add players',
        feature2: 'Remove players',
        feature3: 'Delete watchlists',
      },
      watchlistDetail: {
        infoText: 'You can have up to <1>{{maxPlayers}} players</1> per watchlist.',
      },
      addPlayers: {
        title: 'Add players',
        info: '<0>You can add players to the <1>{{name}} watchlist.</1></0>',
        label: 'Search for player',
      },
      createWatchlist: {
        title: 'Create watchlist',
        infoText:
          'You can create up to {{maxWatchlists}} and add up to {{maxPlayersForWatchlist}} players to each.',
        textUnderInput: 'Max {{maxChars}} characters',
      },
      deleteWatchlistModal: {
        info: "Are you sure you want  to delete permanently <1>'{{name}}'</1> watchlist together with players in that watchlist?",
      },
      addToWatchlist: {
        title: 'Add to watchlist',
        infoText: 'Choose which watchlists you want to add <2>{{name}}</2> to:',
        infoFull1:
          'You have already reached the maximum number of watchlists ({{maxWatchlists}}) and they are all full ({{maxPlayers}} players each).',
        infoFull2: "You won't be able to add any players until you create space.",
      },
      watchlistModal: {
        createNew: 'Create new watchlist',
      },
    },
    strPsq: {
      heading: 'Rate My Game',
      introMsg:
        'Complete these simple questions for us to create you an <1>ITF World Tennis Number</1> until you start competing.',
      infoBox:
        "You'll only be able to fill this in <1>once.</1><2 /><3>You won't be able to change</3> your answers, so please make sure you complete it correctly.",
      review: {
        title: 'Review',
        infoText: "Please review your answers and submit when you're ready.",
      },
      modalConfirm: {
        heading: 'Confirm answers',
        infoText:
          "You'll only be able to submit this form <1>ONCE</1>.<3></3>Please <5>confirm you're happy with the answers</5>.",
      },
      screenCompleted: {
        common: { heading: 'Your number' },
        public: {
          info1:
            "Your answers have been used to generate a <1>World Tennis Number</1> that you'll be able to use until you start competing.",
          info2:
            'Your <1>Singles number</1> has been set as <4>{{wtnSingles}}</4><5/>Your <7>Doubles number</7> has been set as <10>{{wtnDoubles}}</10>',
          info3: 'Claim your profile and begin:',
          info4:
            '<0><1>Improving your rating</1><1>Compare your rating to your clubmates and players around the world</1><1>Track changes to your rating</1><1>Follow friends and opponents and view their results</1><1>Access all of your results in one place</1></0>',
          info5:
            'If your National Association has provided you with a WTN through past match results, this will take precedence over the WTN you have just generated.',
          button: 'Claim my profile',
        },
        registered: {
          info1: 'Thank you for answering our questions.',
          info2:
            "Your answers have been used to generate a <1>World Tennis Number</1> that you'll be able to use until you start competing.",
          info3:
            'Your <1>Singles number</1> has been set as <4>{{wtnSingles}}</4><5/>Your <7>Doubles number</7> has been set as <10>{{wtnDoubles}}</10>',
          info4: 'Enjoy your tennis.',
          button: 'My profile page',
        },
      },
      submitErrorInfo: 'Please refresh or try again later',
      widgetMsg: 'Start competing to get your number',
      widgetText: '',
      widgetLinkText: "Until you start playing fill in our <2>'Rate My Game'</2> questionnaire",
      q1: { question: 'What type of matches do you usually play in?', intro: 'I play:' },
      q2: { question: 'How would you describe your skill level on court?', intro: "I'm:" },
      q3: { question: 'Are you mainly a singles or doubles player?' },
      q4: { question: 'From experience, how often do you hold serve?' },
      q5: {
        question:
          'Thinking back to when you first picked up a racket, how many years have you been playing tennis?',
      },
      q6: { question: 'What is your sex?' },
      q7: { question: 'Please enter your age' },
      q1a1: {
        review: 'I play <strong>for fun</strong> when I get the chance',
        option: '<strong>for fun</strong> when I get the chance',
      },
      q1a2: {
        review: 'I play <strong>casual matches</strong> with friends or family',
        option: '<strong>casual matches</strong> with friends or family',
      },
      q1a3: {
        review:
          'I play <strong>official matches in amateur</strong> tournaments, clubs, leagues or university/school teams',
        option:
          '<strong>official matches in amateur</strong> tournaments, clubs, leagues or university/school teams',
      },
      q1a4: {
        review: 'I play <strong>official matches in county level</strong> tournaments and leagues',
        option: '<strong>official matches in county level</strong> tournaments and leagues',
      },
      q1a5: {
        review:
          'I play <strong>official matches in regional or national</strong> tournaments or leagues',
        option: '<strong>official matches in regional or national</strong> tournaments or leagues',
      },
      q2a1: {
        review:
          "I'm <strong>just starting out</strong> as a tennis player, but would like to play more",
        option:
          '<strong>just starting out</strong> as a tennis player, but would like to play more',
      },
      q2a2: {
        review:
          "I'm <strong>still a beginner</strong> but I've played a few games and I'm gaining confidence",
        option:
          "<strong>still a beginner</strong> but I've played a few games and I'm gaining confidence",
      },
      q2a3: {
        review:
          "I'm <strong>playing regularly</strong> and improving every time I step out onto the court",
        option:
          '<strong>playing regularly</strong> and improving every time I step out onto the court',
      },
      q2a4: {
        review:
          "I'm <strong>an intermediate player.</strong>  I can read my opponent's game and have a wide selection of shots",
        option:
          "<strong>an intermediate player.</strong>  I can read my opponent's game and have a wide selection of shots",
      },
      q2a5: {
        review:
          "I'm <strong>regularly competing in arranged matches </strong> and win fairly often",
        option: '<strong>regularly competing in arranged matches </strong> and win fairly often',
      },
      q2a6: {
        review:
          "I'm <strong>regularly competing in tournaments</strong> and I generally win the matches I play",
        option:
          '<strong>regularly competing in tournaments</strong> and I generally win the matches I play',
      },
      q2a7: {
        review:
          "I'm <strong>regularly competing in competitions and tournaments, </strong>  winning my matches comfortably",
        option:
          '<strong>regularly competing in competitions and tournaments, </strong>  winning my matches comfortably',
      },
      q2a8: {
        review:
          "I'm <strong>regularly entering tournaments </strong> and am always one of the very best players on court",
        option:
          '<strong>regularly entering tournaments </strong> and am always one of the very best players on court',
      },
      q3a1: { review: "I'm a <strong>Singles</strong> player", option: '<strong>Singles</strong>' },
      q3a2: { review: "I'm a <strong>Doubles</strong> player", option: '<strong>Doubles</strong>' },
      q4a1: {
        review: "<strong>I rarely win</strong> the point when I'm serving",
        option: "<strong>I rarely win</strong> the point when I'm serving",
      },
      q4a2: {
        review: '<strong>I compete for every point</strong> but am sometimes beaten on my serve',
        option: '<strong>I compete for every point</strong> but am sometimes beaten on my serve',
      },
      q4a3: {
        review: '<strong>I win nearly all</strong> of my points when serving',
        option: '<strong>I win nearly all</strong> of my points when serving',
      },
      q4a4: { review: "I'm not too sure", option: "I'm not too sure" },
      q5a1: {
        review: "I've been playing for <strong>Less than 1</strong> year",
        option: '<strong>Less than 1</strong> year',
      },
      q5a2: {
        review: "I've been playing for <strong>1 - 2</strong> years",
        option: '<strong>1 - 2</strong> years',
      },
      q5a3: {
        review: "I've been playing for <strong>2 - 5</strong> years",
        option: '<strong>2 - 5</strong> years',
      },
      q5a4: {
        review: "I've been playing for <strong>5 - 10</strong> years",
        option: '<strong>5 - 10</strong> years',
      },
      q5a5: {
        review: "I've been playing for <strong>10 - 20</strong> years",
        option: '<strong>10 - 20</strong> years',
      },
      q5a6: {
        review: "I've been playing for <strong>More than 20 </strong> years",
        option: '<strong>More than 20 </strong> years',
      },
      q6a1: { review: "I'm <strong>male</strong>", option: '<strong>Male</strong>' },
      q6a2: { review: "I'm <strong>female</strong>", option: '<strong>Female</strong>' },
      q7a1: "I'm <strong>{{value}}</strong>",
    },
    strPolicies: {
      heading: 'ITF World Tennis Number Privacy and Cookie Policies',
      intro: 'View our policies for',
      under18: 'under 18 years old',
      over18: 'over 18 years old',
      cookiePolicy: 'cookie policy',
    },
    strSocialMatches: {
      submitAScore: {
        title: 'Post a score',
        info: 'Add a result of a tennis match you played',
      },
      myScores: {
        title: 'my scores',
        titleOther: 'scores',
        info: {
          pending:
            'Pending scores will be automatically accepted after 72 hours from the date of submission.',
          rejected:
            'Rejected scores will be automatically deleted after 3 months from the date of submission.',
        },
        submitted: 'accepted',
        pending: 'pending',
        rejected: 'rejected',
        matchCard: {
          menu: {
            delete: 'Delete score',
          },
          pending: {
            info: 'waiting for your opponent to accept this score',
          },
          rejected: {
            info: {
              opponent: 'score rejected by opponent',
              me: 'score rejected by you',
              partner: 'score rejected by your partner',
            },
          },
        },
        noScoresPanel: {
          getStarted: {
            title: "Let's get started!",
            info: 'Your scores will appear here after you post them',
          },
          approved: {
            title: "You don't have accepted scores yet",
            info: 'Accepted scores will appear here once you or your opponent accept them',
          },
          pending: {
            title: "You don't have pending scores currently",
            info: 'Your pending scores will appear here after you or your opponent post them',
          },
          rejected: {
            title: "You don't have rejected scores",
            info: 'Your rejected scores will appear here if you or your opponent reject a pending score',
          },
          otherPlayer: {
            title: 'No matches found',
            info: "{{firstName}} hasn't posted any matches yet",
          },
        },
      },
      modals: {
        approve: {
          header: 'accepting score',
          info: {
            1: "you'll see this score publicly posted on your profile immediately.",
            2: 'are you sure you want to accept the score?',
          },
          checkbox: "Don't show this again",
          list: {
            1: '<0>{{ fullName }} has accepted your invitation to join <3>ITF World Tennis Number</3></0>',
          },
        },
        reject: {
          header: 'rejecting score',
          info: {
            1: 'this score will be deleted and will not be publicly posted anywhere.',
            2: 'are you sure you want to reject the score?',
          },
          checkbox: "Don't show this again",
        },
        delete: {
          header: 'delete score',
          info: {
            1: 'Are you sure you want to delete the score played on {{datePlayed}}?',
            2: 'This action cannot be reversed.',
          },
        },
        addPlayer: {
          header: 'Add player',
          searchBarLabel: 'Search for a player',
          addPlayer: 'Add player',
          added: 'Already added',
          shareLinkBtn: 'Copy registration link',
          selectPlayer: 'Select the player you would like to add:',
          shareLinkText:
            "Can't find a player? They may not be registered or ineligible for an account. Please read our <2>FAQs</2> before inviting players.",
        },
        infoPending: {
          header: 'Pending score',
          info: {
            1: 'Your opponent or partner will have 72 hours to accept or reject the score. If the score has not been responded to, it will automatically be accepted.',
            2: 'Only when your opponent has approved it will it appear on all player accounts.',
          },
        },
      },
      postScore: {
        title: 'Post your score',
        subtitle: 'Post your score for calculation towards your World Tennis Number',
        modals: {
          info: {
            title: 'Submit score info',
            info: {
              1: 'Self-submitted scores are not verified.',
              2: "Scores won't be publicly posted to your opponent's profile or count towards your World Tennis Number until they have been approved by your opponent.",
              3: "If you've made a mistake, you can easily delete and resubmit the score.",
            },
          },
        },
        links: {
          backToMyScores: 'Go to my scores',
        },
        matchDate: { title: 'Match date' },
        matchType: { title: 'Match type' },
        matchFormat: {
          title: 'Match format',
          options: {
            '3s6g': {
              name: '3 Sets: First to 6 games',
              helperText:
                '<0>You play up to three tie-break sets to six games – first player to win two, wins the match.</0><1>Each set must be by two clear games (e.g., 6-4) – if the score goes to 6-6, then you play a seven point tie-break to decide the winner.</1>',
            },
            '2s6g': {
              name: '2 Sets: First to 6 games',
              helperText:
                '<0>You play two tie-break sets to six games, with a match tie-break (up to 10 points) to decide the winner at one set all.</0><1>Each set must be by two clear games (e.g., 6-4) – if the score goes to 6-6, then you play a seven point tie-break to decide the winner.</1><2>The match tie-break is a race to 10 points but must also be won by two clear points</2>',
            },
            '2s4g': {
              name: '2 Sets: First to 4 games',
              helperText:
                '<0>You play two short tie-break sets to four games, with a match tie-break (up to 10 points) to decide the winner at one set all.</0><1>Each set must be by two clear games (e.g., 4-2) – if the score goes to 3-3, then you play a seven point tie-break to decide the winner.</1><2>The match tie-break is a race to 10 points but must also be won by two clear points.</2>',
            },
            '1s6g': {
              name: '1 Set: First to 6 games',
              helperText:
                '<0>You play one tie-break set to six games – whoever wins, claims the match.</0><1>The set must be by two clear games (e.g., 6-4) – if the score goes to 6-6, then you play a seven point tie-break to decide the winner.</1>',
            },
            '10p': {
              name: 'First to 10 points',
              helperText:
                '<0>You play first to 10 points in a tie-break format – alternating server after the first point and then every two points for the rest of the match.</0><1>You can only win by two clear points, so if the score goes to 9-9 you keep playing, e.g. you could win 18-16.</1>',
            },
          },
          infoBoxTitle: 'What does this match format mean?',
        },
        matchScore: {
          title: 'Enter scores',
          playerCard: {
            addPlayer: 'Add player',
            winner: 'wins',
            sideRef: {
              singles: 'Player',
              doubles: 'Team',
            },
          },
          label: {
            set: 'set',
            tiebreak: 'tiebreak',
            superTiebreak: 'tiebreak',
          },
        },
        success: {
          title: 'Score submitted - Thanks',
          list: {
            info: "You'll see this publicly posted on your profile once your opponent:",
            1: 'signs up to ITF World Tennis Number',
            2: 'and confirms the result',
          },
          btn: {
            back: 'back to results',
            submitNew: 'submit new score',
          },
        },
        scoreValidationError: {
          invalidScore: 'Invalid score entry',
        },
      },
    },
    strFilters: {
      genderDefaultLabel: 'Any Gender',
      male: 'Male',
      female: 'Female',
      anyGender: 'Gender',
      anyGenderOption: 'Any gender',
      nonBinary: 'Non-Binary',
      anyAgeGroup: 'Age group',
      ageGroupCompositeDropdownLabel: 'Age: {{ageGroup}}',
      ageGroupBornInLabel: 'Born {{birthYear}}',
      countries: 'Countries',
      yes: 'yes',
      no: 'no',
      filterBy: 'Filter by',
      countryDefaultLabel: 'Nationality',
      nationalityCompositeDropdownLabel: 'Nationality: +{{numberSelected}}',
      clearFilter: 'Clear filter',
      countryFilterPlaceholder: 'Type to filter...',
      wtnRange: 'WTN Range',
      apply: 'APPLY FILTER',
      cancel: 'CANCEL',
      rangeLabel: '{{range}} Rating',
      rangeLabelSingles: 'Singles number',
      rangeLabelDoubles: 'Doubles number',
      clearFilters: 'Clear filters',
      filters: 'Filters',
      minRating: 'Min rating',
      maxRating: 'Max rating',
      rating: {
        radioAllPlayers: 'All players',
        radioRatingRange: 'Rating range',
        labelDropdownCombined: 'WTN Rating',
        labelRatingType: 'Rating type',
        labelConfidenceLevel: 'Confidence level',
        labelGameZone: 'My Game zONe',
        defaultLabelSingles: 'Singles number',
        defaultLabelDoubles: 'Doubles number',
        radioSingles: 'Singles',
        radioDoubles: 'Doubles',
        radioConfidenceHigh: 'High confidence (verified)',
        radioConfidenceAll: 'All',
        compositeDropdownLabel: '{{appliedLabel}}: {{min}}-{{max}}',
        inputError: 'Allowed values are between {{max}} and {{min}} with only one decimal.',
      },
      confidenceModal: {
        title: 'Number Verification',
        subtitle: 'Your number has a verification tick, this relates to degree of confidence',
        featureConfidenceHigh: {
          title: 'Confident',
          items: {
            1: 'We have <1>lots of results</1> for you so have a better understanding of your ability',
            2: ' You can be <1>confident your Number is accurate</1>',
          },
        },
        featureConfidenceLow: {
          title: 'More data required',
          items: {
            1: 'We need <1>more recent results</1> for you in order to better understand your ability',
            2: 'Your number may <1>not be as accurate as it could be</1>',
          },
        },
        ariaLabel: {
          tickHigh: 'Blue confidence ribbon',
          tickLow: 'Grey confidence ribbon',
          exampleNumber: 'Example number',
        },
      },
      gameZoneModal: {
        title: 'Game zONe',
        register: {
          info: '<0>This feature is available to registered users only.</0>',
          button: '<0>register now</0>',
        },
        content:
          "<0>Our Game zONe identifies a range of potential opponents whose Numbers are close to yours on the scale.</0><1><0>Game zONe will find evenly-matched opponents wherever you are, to ensure the best possible experience on court</0><1>Our industry-leading algorithm analyses player performance data and millions of match results.</1></1><2>Don't forget, as your Number changes, your Game zONe will change too, so be sure to check back regularly to find new opponents to play.</2>",
      },
    },
    strProviderLink: {
      content: '<0>Data supplied by the {{providerName}}. </0>',
      landing: '<0>View details on the <2>{{providerName}} website</2>.</0>',
      support: '<0>Something not right? <2>Contact the {{providerName}}</2>.</0>',
    },
  },
  es: {
    strCommon: {
      confirm: 'confirmar',
      of: 'de',
      cancel: 'cancelar',
      or: 'o',
    },
    strCommonUI: {
      button: {
        signIn: 'Iniciar sesión',
        signOut: 'Cerrar sesión',
        userProfile: 'Perfil de Usuario',
        continue: 'Continuar',
        accessAccount: 'Acceder a mi cuenta',
        updateInfo: 'Actualizar información',
        completeProfile: 'Completar perfil',
        updateDetails: 'Actualizar detalles',
        updateEmail: 'Actualizar email',
        updatePassword: 'Actualizar contraseña',
        save: 'Guardar',
        rename: 'Renombrar',
        delete: 'Eliminar',
        cancel: 'cancelar',
        add: 'agregar',
        addPlayers: 'Agregar jugadores',
        invitePlayers: 'Invitar jugadores',
        createWatchlist: 'Crear lista de seguimiento',
        remove: 'eliminar',
        update: 'actualizar',
        updated: 'actualizado',
        edit: 'editar',
        back: 'atrás',
        submit: 'enviar',
        confirm: 'confirmar',
        postScore: 'publicar resultado',
        reject: 'rechazar',
        accept: 'aceptar',
        okGotIt: 'Ok, entendido',
        singles: 'Individuales',
        doubles: 'Dobles',
        subscribe: 'suscribirse',
        postAScore: 'Publicar un resultado',
        new: 'NUEVO',
        join: 'unirse',
        yesDelete: 'sí, eliminar',
        noCancel: 'no, cancelar',
        close: 'cerrar',
        done: 'listo',
        clear: 'Limpiar',
        clearTextField: 'limpiar campo de texto',
        applyFilter: 'Aplicar filtro',
        exportCsv: 'Exportar a CSV',
        manage: 'Gestionar',
        seeError: 'ver detalles del error',
        copyToClipboard: 'Copiar al portapapeles',
        register: 'Registrarse',
        subscribeToNewsletter: 'Suscribirse a nuestro boletín',
      },
      link: {
        here: 'aquí',
        clickHere: 'Haz clic aquí',
        back: 'Atrás',
        backTo: 'Volver a {{name}}',
        myProfile: 'Mi perfil',
        myAccount: 'Mi cuenta',
        news: 'Noticias',
        myWatchlists: 'Mis listas de seguimiento',
        goToWatchlists: 'Ir a Mis listas de seguimiento',
      },
      select: {
        pleaseChoose: 'Por favor, elige...',
      },
      form: {
        allFieldsMandatory:
          'Todos los campos son obligatorios a menos que se indique lo contrario.',
        required: 'es requerido',
        invalid: 'es inválido',
        consent: 'Consentimiento',
        firstName: 'Nombre',
        lastName: 'Apellido',
        dob: 'Fecha de nacimiento',
        inputDayPlaceholder: 'dd',
        inputMonthPlaceholder: 'mm',
        inputYearPlaceholder: 'aaaa',
        sex: 'Sexo',
        sexMale: 'Masculino',
        sexFemale: 'Femenino',
        nationality: 'Nacionalidad',
        residence: 'País de residencia',
        email: 'Email',
        password: 'contraseña',
        watchlistName: 'nombre de lista de seguimiento',
        parentGuardianName: 'Nombre completo del padre o tutor',
        parentGuardianEmail: 'Email del padre o tutor',
        personaSelect: '¿Qué describe mejor tu participación en el tenis?',
        pleaseSpecify: 'Por favor especifica',
        charsRemaining: '{{count}} caracteres restantes',
        whereDidYouHearAboutUs: '¿Dónde supiste de nosotros? (Opcional)',
        whereDidYouHearAboutUsSelect: '¿Dónde supiste de nosotros? (Opcional)',
        validationErrors: {
          minMaxChars: 'debe tener entre {{minLength}} y {{maxLength}} caracteres',
          maxChars: '{{name}} debe tener menos de {{maxLength}} caracteres',
          maxCharsExceeded: 'Número máximo de caracteres excedido',
          dobInThePast: 'La fecha de nacimiento debe ser una fecha pasada',
          minAge: 'La edad mínima es {{minAge}}',
          maxAge: 'La edad máxima es {{maxAge}}',
          minAgeToRegister: 'Debes tener al menos {{minAge}} años para registrarte en WTN',
          minAgeForService: 'Debes tener al menos {{minAge}} años para usar WTN',
          minHeight: 'Altura mínima permitida: {{minHeightMetric}} ({{minHeightImperial}})',
          maxHeight: 'Altura máxima permitida: {{maxHeightMetric}} ({{maxHeightImperial}})',
          onlyAlphanumeric: 'Solo se permiten valores alfanuméricos',
          watchlistNameRequired: 'Por favor agrega un nombre para la lista de seguimiento',
          watchlistNameExists: 'Ya tienes una lista de seguimiento con este nombre',
          invalidValue: 'Valor inválido',
        },
      },
      placeholder: {
        searchResidence: 'Escribe residencia...',
        searchNationality: 'Escribe nacionalidad...',
        personaDetails: 'Ingresa un rol...',
        whereHeardDetails: 'Ingresa dónde supiste de nosotros...',
        searchNA: 'Escribe Asociación Nacional...',
        searchNationalAssociation: 'Escribe Asociación Nacional...',
      },
      ariaLabel: {
        accountMenu: 'Menú de Cuenta',
        pendingMatchMenu: 'Menú de opciones de partido social',
        moreInfo: 'Más información',
        moreOptions: 'Más opciones',
        noRating: 'No hay puntuación disponible',
        watchlistIncludedBtn:
          'Jugador incluido en Lista de seguimiento, haz clic para eliminar jugador',
        watchlistNotIncludedBtn:
          'Jugador no incluido en Lista de seguimiento, haz clic para agregar jugador',
        loading: 'Cargando',
        joinWtn: 'Unirse a WTN',
        mobileNavigation: 'Navegación móvil',
        mainNavigation: 'Navegación principal',
      },
      badge: {
        new: 'NUEVO',
      },
      menu: 'Menú',
      userProfile: 'Usuario',
      selectLanguage: 'Seleccionar idioma',
      availableLanguages: 'Idiomas disponibles',
    },
    strSearchBar: {
      placeholderDefault: 'Buscar',
      placeholder: 'Escribe apellido o ID de Tenis...',
      viewAll: 'Ver todos {{type}}',
      notFound: 'No se encontraron {{type}}',
      player: 'jugador',
      players: 'jugadores',
      vs: 'VS',
      h2hSearchCompare: 'Elige jugadores para comparar en los cuadros de arriba',
      h2hSingleSearchCompare: 'Elige un jugador para comparar en el cuadro de arriba',
    },
    strFilterBar: {
      genderDefaultLabel: 'Cualquier Género',
      male: 'Masculino',
      female: 'Femenino',
      anyGender: 'Género',
      anyGenderOption: 'Cualquier género',
      nonBinary: 'No Binario',
      anyAgeGroup: 'Grupo de edad',
      ageGroupCompositeDropdownLabel: 'Edad: {{ageGroup}}',
      ageGroupBornInLabel: 'Nacido en {{birthYear}}',
      countries: 'Países',
      yes: 'sí',
      no: 'no',
      filterBy: 'Filtrar por',
      countryDefaultLabel: 'Nacionalidad',
      nationalityCompositeDropdownLabel: 'Nacionalidad: +{{numberSelected}}',
      clearFilter: 'Limpiar filtro',
      countryFilterPlaceholder: 'Escribe para filtrar...',
      rating: {
        radioAllPlayers: 'Todos los jugadores',
        radioRatingRange: 'Rango de puntuación',
        labelDropdownCombined: 'Puntuación WTN',
        labelRatingType: 'Tipo de puntuación',
        labelConfidenceLevel: 'Nivel de confianza',
        defaultLabelSingles: 'Número de individuales',
        defaultLabelDoubles: 'Número de dobles',
        radioSingles: 'Individuales',
        radioDoubles: 'Dobles',
        radioConfidenceHigh: 'Alta confianza (verificado)',
        radioConfidenceAll: 'Todos',
        compositeDropdownLabel: '{{appliedLabel}}: {{min}}-{{max}}',
        inputError: 'Los valores permitidos están entre {{max}} y {{min}} con solo un decimal.',
        confidenceModal: {
          title: 'Verificación de Número',
          tickHigh: 'Cinta de confianza azul',
          tickLow: 'Cinta de confianza gris',
          exampleNumber: 'Número de ejemplo',
        },
      },
      wtnRange: 'Rango WTN',
      apply: 'APLICAR FILTRO',
      cancel: 'CANCELAR',
      rangeLabel: 'Puntuación {{range}}',
      rangeLabelSingles: 'Número de individuales',
      rangeLabelDoubles: 'Número de dobles',
      clearFilters: 'Limpiar filtros',
      filters: 'Filtros',
      minRating: 'Puntuación mínima',
      maxRating: 'Puntuación máxima',
    },
    searchResults: {
      wtn: 'WTN',
      searching: 'Buscando resultados...',
      tableResultsInfo: 'Mostrando {{showing}} de miles de resultados',
      tableResultsInfoWithTotal: 'Mostrando {{showing}} de {{total}} resultados',
      nationalityHeading: 'Nacionalidad',
      ageGroupHeading: 'Grupo de edad',
      playersHeading: 'Jugadores',
      singlesHeading: 'Número de individuales',
      doublesHeading: 'Número de dobles',
      age: 'Edad',
      loadMore: 'CARGAR MÁS',
      showMore: 'MOSTRAR MÁS',
      noPlayers:
        'No se encontraron jugadores. Por favor ingresa un nombre de jugador antes de aplicar los filtros',
      modalHeader: 'Resultados cara a cara',
    },
    strCharts: {
      singles: 'Individuales',
      doubles: 'Dobles',
      both: 'Ambos',
      wins: 'Victorias',
      losses: 'Derrotas',
      winLossRecordsKey: ['Victorias', 'Derrotas', 'Walkovers', 'Retiros'],
      wtnHistory: 'Historial WTN',
      singlesWinLoss: 'Registro victorias-derrotas individuales',
      doublesWinLoss: 'Registro victorias-derrotas dobles',
      bothWinLoss: 'Registro victorias-derrotas individuales y dobles',
      errorFetchingData: 'Ha ocurrido un error al obtener los datos. Por favor intenta más tarde.',
      noData: 'No hay resultados disponibles para el rango de fechas seleccionado',
      noDataShort: 'No hay resultados disponibles',
      noDataGeneric: 'Lo sentimos, no hay datos disponibles',
      noDataTournaments: 'Lo sentimos, no hay datos disponibles. Por favor selecciona otro año',
    },
    strDateFilter: {
      allTime: 'Todo el tiempo',
      oneMonth: 'Último Mes',
      nMonths: 'Últimos {{months}} meses',
      nYears: 'Últimos {{years}} años',
    },
    strMobileFilter: {
      filters: 'Filtros',
      filtersWithCount: 'Filtros ({{count}})',
      filtersAndSort: 'Filtros y Orden',
      filtersAndSortWithCount: 'Filtros y Orden ({{count}})',
      gameType: 'Tipo de juego',
      year: 'año',
      reset: 'Restablecer',
      clearAll: 'Limpiar todo',
      gender: 'Género',
      ageGroup: 'Grupo de edad',
      anyAgeGroupOption: 'Cualquier grupo de edad',
      nationality: 'Nacionalidad',
      anyNationality: 'Cualquier nacionalidad',
      rating: 'Puntuación WTN',
      anyRating: 'Todos los jugadores',
      sortBy: 'Ordenar por',
      sortingLabelSingles: 'Número de individuales',
      sortingLabelDoubles: 'Número de dobles',
      sortingLabelName: 'Nombre del jugador',
      cancel: 'Cancelar',
      goBack: 'Atrás',
      updateFilters: 'Aplicar Filtros',
      timePeriod: 'Período de tiempo',
    },
    strProfileHeader: {
      age: 'Edad',
      bornIn: 'Nacido en',
      under: 'Bajo',
      editProfile: 'Editar perfil',
      addToWatchlist: 'Agregar a lista de seguimiento',
      removeFromWatchlist: 'Eliminar de lista de seguimiento',
      singlesWtn: 'WTN Individuales',
      doublesWtn: 'WTN Dobles',
      WTNDefinition:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      additionalInfo: 'Información Adicional',
      residence: 'Residencia',
      eventsPlayed: 'Eventos jugados',
      preferredHand: 'Mano preferida',
      height: 'Altura',
      favouriteShot: 'Golpe favorito',
      backhand: 'Revés',
      clubsAssociations: 'Clubes y asociaciones',
    },
    strGuidedTour: {
      overview: {
        title: 'Resumen',
        content:
          'Encuentra tu Número de Tenis Mundial ITF en tiempo real, Zona de Juego, estadísticas de partidos y tu historial de puntuación.',
      },
      results: {
        title: 'Resultados',
        content:
          'Ve todos los resultados de partidos que tenemos para ti. Puedes filtrar por meses, días y años.',
      },
      headToHead: {
        title: 'Cara a Cara',
        content:
          'Busca y compárate con otros jugadores en la comunidad del Número de Tenis Mundial ITF.',
      },
      yourNumber: {
        title: 'Tu número',
        content:
          'Compara Números con otros, mira tu historial de partidos y competidores en común.',
      },
      watchlist: {
        title: 'Lista de seguimiento',
        content: 'Mantén un seguimiento de tus jugadores favoritos, amigos, colegas y familia.',
      },
      competitions: {
        title: 'Competiciones',
        content:
          "<0>Bajo la función de 'Competiciones', todos los resultados de partidos de competición que hayan sido enviados por una Asociación Nacional o Regional, o la ITF, se mostrarán aquí.</0><1>Visita tu perfil para ver tus resultados de competición.</1><2>Ten en cuenta que los jugadores no podrán enviar resultados de torneos aquí.</2>",
        contentOwnProfile:
          '<0>Todos los resultados de partidos de competición que hayan sido enviados por tu Asociación Nacional o Regional, o la ITF, aparecerán en esta pestaña.</0><1>Ten en cuenta que no podrás enviar puntuaciones aquí.</1>',
      },
      myMatches: {
        title: 'Mis Partidos',
        content:
          '<0><0>¡NUEVO!</0> Los jugadores ahora pueden publicar puntuaciones para los partidos jugados fuera de torneos.</0><1>Visita tu perfil para comenzar a publicar puntuaciones.</1><2>Ten en cuenta que los jugadores solo podrán enviar un resultado contra un oponente que tenga una cuenta del <1>Número de Tenis Mundial ITF</1>, sin embargo esto excluye a Juniors y Profesionales de IPIN.</2>',
        contentOwnProfile:
          '<0><0>¡NUEVO!</0> Ahora puedes publicar puntuaciones para los partidos que jugaste fuera de torneos.</0><1>Ten en cuenta que solo podrás enviar un resultado contra un jugador que tenga una cuenta del <2>Número de Tenis Mundial ITF</2>, sin embargo esto excluye a Juniors y Profesionales de IPIN.</1>',
      },
    },
    strScaleModal: {
      aboutWTNHeader: 'Acerca del Número de Tenis Mundial',
      okGotItButton: 'VALE, ENTENDIDO',
      aboutWTNContent:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam minima tenetur nisi obcaecati nihil aliquam dolor accusantium nemo eum rem, quis, non molestiae eos possimus praesentium pariatur, provident doloribus nostrum.',
    },
    strProfile: {
      sections: {
        overview: 'resumen',
        results: 'resultados',
        h2h: 'cara-a-cara',
        competitions: 'competiciones',
        socialMatches: 'mis partidos',
      },
      overview: 'Resumen',
      playerStats: 'Estadísticas del Jugador',
      comparePlayers: 'Comparar jugadores',
      headToHead: 'Cara a Cara',
      wtnHistory: 'Historial del Número de Tenis Mundial',
      playerTournMatches: 'Partidos de torneos del jugador',
      resultsSummary: 'Resumen de resultados',
      h2hSearchDescription: 'Selecciona jugadores para comparar <2>{{name}}</2> con',
      pageNotFound: 'La página que solicitaste no se puede encontrar.',
      invalidPlayerId: 'Este ID de jugador es inválido',
      error: 'Error',
      defaultErrorMsg: 'Algo salió mal...',
      problemLoadingProfile: 'Se encontró un error al cargar este perfil de jugador. ',
      navigateBack: 'Por favor navega de vuelta a la',
      homepage: 'página principal',
      notFound: 'Jugador No Encontrado',
      selectAnotherPage: 'o selecciona otra página del menú de navegación.',
      modals: {
        info: {
          competitions:
            "<0>Bajo la función de 'Competiciones', todos los resultados de partidos de competición que hayan sido enviados por tu Asociación Nacional o Regional, o la ITF, se mostrarán aquí.</0><1>Ten en cuenta que no podrás enviar resultados de torneos aquí.</1>",
          myMatches:
            "<0>Bajo la función de 'Mis Partidos', ahora puedes publicar puntuaciones para los partidos que jugaste fuera de torneos.</0><2>Ten en cuenta que solo podrás enviar un resultado contra un jugador que tenga una cuenta del <1>Número de Tenis Mundial ITF</1>, sin embargo esto excluye a Juniors y Profesionales de IPIN.</2><4>Una vez que se envíe una puntuación, se enviará un email a tu oponente pidiéndole que confirme el resultado(s) del partido. Si no hay respuesta dentro de 72 horas, esto se verificará automáticamente.</4>",
        },
      },
    },
    strSocialMatches: {
      submitAScore: {
        title: 'Publicar una puntuación',
        info: 'Agrega un resultado de un partido de tenis que jugaste',
      },
      myScores: {
        title: 'mis puntuaciones',
        titleOther: 'puntuaciones',
        info: {
          pending:
            'Las puntuaciones pendientes se aceptarán automáticamente después de 72 horas desde la fecha de envío.',
          rejected:
            'Las puntuaciones rechazadas se eliminarán automáticamente después de 3 meses desde la fecha de envío.',
        },
        submitted: 'aceptado',
        pending: 'pendiente',
        rejected: 'rechazado',
        matchCard: {
          menu: {
            delete: 'Eliminar puntuación',
          },
          pending: {
            info: 'esperando que tu oponente acepte esta puntuación',
          },
          rejected: {
            info: {
              opponent: 'puntuación rechazada por el oponente',
              me: 'puntuación rechazada por ti',
              partner: 'puntuación rechazada por tu compañero',
            },
          },
        },
        noScoresPanel: {
          getStarted: {
            title: '¡Comencemos!',
            info: 'Tus puntuaciones aparecerán aquí después de que las publiques',
          },
          approved: {
            title: 'Aún no tienes puntuaciones aceptadas',
            info: 'Las puntuaciones aceptadas aparecerán aquí una vez que tú o tu oponente las acepten',
          },
          pending: {
            title: 'Actualmente no tienes puntuaciones pendientes',
            info: 'Tus puntuaciones pendientes aparecerán aquí después de que tú o tu oponente las publiquen',
          },
          rejected: {
            title: 'No tienes puntuaciones rechazadas',
            info: 'Tus puntuaciones rechazadas aparecerán aquí si tú o tu oponente rechazan una puntuación pendiente',
          },
          otherPlayer: {
            title: 'No se encontraron partidos',
            info: '{{firstName}} aún no ha publicado ningún partido',
          },
        },
      },
      modals: {
        approve: {
          header: 'aceptando puntuación',
          info: {
            1: 'verás esta puntuación publicada públicamente en tu perfil inmediatamente.',
            2: '¿estás seguro de que quieres aceptar la puntuación?',
          },
          checkbox: 'No mostrar esto de nuevo',
          list: {
            1: '<0>{{fullName}} ha aceptado tu invitación a unirse al <3>Número de Tenis Mundial ITF</3></0>',
          },
        },
        reject: {
          header: 'rechazando puntuación',
          info: {
            1: 'esta puntuación se eliminará y no se publicará públicamente en ningún lugar.',
            2: '¿estás seguro de que quieres rechazar la puntuación?',
          },
          checkbox: 'No mostrar esto de nuevo',
        },
        delete: {
          header: 'eliminar puntuación',
          info: {
            1: '¿Estás seguro de que quieres eliminar la puntuación jugada el {{datePlayed}}?',
            2: 'Esta acción no se puede revertir.',
          },
        },
        addPlayer: {
          header: 'Agregar jugador',
          searchBarLabel: 'Buscar un jugador',
          addPlayer: 'Agregar jugador',
          added: 'Ya agregado',
          shareLinkBtn: 'Copiar enlace de registro',
          selectPlayer: 'Selecciona el jugador que te gustaría agregar:',
          shareLinkText:
            '¿No puedes encontrar un jugador? Puede que no esté registrado o no sea elegible para una cuenta. Por favor lee nuestras <2>Preguntas Frecuentes</2> antes de invitar jugadores.',
        },
        infoPending: {
          header: 'Puntuación pendiente',
          info: {
            1: 'Tu oponente o compañero tendrá 72 horas para aceptar o rechazar la puntuación. Si no se ha respondido a la puntuación, se aceptará automáticamente.',
            2: 'Solo cuando tu oponente la haya aprobado aparecerá en todas las cuentas de jugadores.',
          },
        },
      },
      postScore: {
        title: 'Publica tu puntuación',
        subtitle: 'Publica tu puntuación para el cálculo hacia tu Número de Tenis Mundial',
        modals: {
          info: {
            title: 'Información de envío de puntuación',
            info: {
              1: 'Las puntuaciones auto-enviadas no están verificadas.',
              2: 'Las puntuaciones no se publicarán públicamente en el perfil de tu oponente ni contarán para tu Número de Tenis Mundial hasta que hayan sido aprobadas por tu oponente.',
              3: 'Si has cometido un error, puedes eliminar y reenviar fácilmente la puntuación.',
            },
          },
        },
        links: {
          backToMyScores: 'Ir a mis puntuaciones',
        },
        matchDate: { title: 'Fecha del partido' },
        matchType: { title: 'Tipo de partido' },
        matchFormat: {
          title: 'Formato del partido',
          options: {
            '3s6g': {
              name: '3 Sets: Primero a 6 juegos',
              helperText:
                '<0>Juegas hasta tres sets de tie-break a seis juegos – el primer jugador en ganar dos, gana el partido.</0><1>Cada set debe ser por dos juegos claros (ej., 6-4) – si la puntuación llega a 6-6, entonces juegas un tie-break de siete puntos para decidir el ganador.</1>',
            },
            '2s6g': {
              name: '2 Sets: Primero a 6 juegos',
              helperText:
                '<0>Juegas dos sets de tie-break a seis juegos, con un tie-break de partido (hasta 10 puntos) para decidir el ganador en caso de un set para cada uno.</0><1>Cada set debe ser por dos juegos claros (ej., 6-4) – si la puntuación llega a 6-6, entonces juegas un tie-break de siete puntos para decidir el ganador.</1><2>El tie-break de partido es una carrera a 10 puntos pero también debe ganarse por dos puntos claros</2>',
            },
            '2s4g': {
              name: '2 Sets: Primero a 4 juegos',
              helperText:
                '<0>Juegas dos sets cortos de tie-break a cuatro juegos, con un tie-break de partido (hasta 10 puntos) para decidir el ganador en caso de un set para cada uno.</0><1>Cada set debe ser por dos juegos claros (ej., 4-2) – si la puntuación llega a 3-3, entonces juegas un tie-break de siete puntos para decidir el ganador.</1><2>El tie-break de partido es una carrera a 10 puntos pero también debe ganarse por dos puntos claros.</2>',
            },
            '1s6g': {
              name: '1 Set: Primero a 6 juegos',
              helperText:
                '<0>Juegas un set de tie-break a seis juegos – quien gane, se lleva el partido.</0><1>El set debe ser por dos juegos claros (ej., 6-4) – si la puntuación llega a 6-6, entonces juegas un tie-break de siete puntos para decidir el ganador.</1>',
            },
            '10p': {
              name: 'Primero a 10 puntos',
              helperText:
                '<0>Juegas primero a 10 puntos en formato tie-break – alternando el saque después del primer punto y luego cada dos puntos por el resto del partido.</0><1>Solo puedes ganar por dos puntos claros, así que si la puntuación llega a 9-9 sigues jugando, ej. podrías ganar 18-16.</1>',
            },
          },
          infoBoxTitle: '¿Qué significa este formato de partido?',
        },
        matchScore: {
          title: 'Ingresar puntuaciones',
          playerCard: {
            addPlayer: 'Agregar jugador',
            winner: 'gana',
            sideRef: {
              singles: 'Jugador',
              doubles: 'Equipo',
            },
          },
          label: {
            set: 'set',
            tiebreak: 'tiebreak',
            superTiebreak: 'tiebreak',
          },
        },
        success: {
          title: 'Puntuación enviada - Gracias',
          list: {
            info: 'Verás esto publicado públicamente en tu perfil una vez que tu oponente:',
            1: 'se registre en el Número de Tenis Mundial ITF',
            2: 'y confirme el resultado',
          },
          btn: {
            back: 'volver a resultados',
            submitNew: 'enviar nueva puntuación',
          },
        },
        scoreValidationError: {
          invalidScore: 'Entrada de puntuación inválida',
        },
      },
    },
    strPlayerStats: {
      matchActivityTitle: 'Actividad de partidos',
      daysSinceLastMatchTitle: 'Días desde el último partido:',
      uniqueSinglesTitle: 'Oponentes únicos en individuales:',
      singlesIntervalTitle: 'Intervalo promedio de individuales:',
      doublesIntervalTitle: 'Intervalo promedio de dobles:',
      ratingHighsAndLows: 'Rango de puntuación',
      lowestTitle: 'Más bajo',
      highestTitle: 'Más alto',
      pastYeartitle: 'Año Pasado',
      allTimeTitle: 'De Todos los Tiempos',
      days: 'días',
      singles: 'Individuales',
      doubles: 'Dobles',
    },
    strMatchHistory: {
      matchHistory: 'Historial de partidos',
      noMatchHistory: 'No se encontró historial de partidos',
      date: 'Fecha',
      tournament: 'Torneo',
      draw: 'Cuadro',
      winner: 'Ganador',
      score: 'Puntuación',
      headToHead: 'Cara-a-Cara',
      percentageWins: '% victorias',
      wtn: 'WTN',
      time: 'vez',
      times: 'veces',
      notCompeted: 'Estos jugadores no han competido',
      close: 'Cerrar',
    },
    strH2H: {
      age: 'Edad',
      yearOfBirth: 'Año de Nacimiento',
      gender: 'Género',
      nationality: 'Nacionalidad',
      wtnSingles: 'NÚMERO DE INDIVIDUALES',
      wtnDoubles: 'NÚMERO DE DOBLES',
      wins: 'victoria',
      wins_plural: 'victorias',
      winsWithCount: '{{count}} victoria',
      winsWithCount_plural: '{{count}} victorias',
      winLikelihood: {
        singlesLabel: 'PROBABILIDAD DE VICTORIA EN INDIVIDUALES',
        doublesLabel: 'PROBABILIDAD DE VICTORIA EN DOBLES',
        score: {
          over: 'Más de {{score}}%',
          under: 'Menos de {{score}}%',
          exact: '{{score}}%',
        },
        unavailable: 'Predicción no disponible',
        lowConfidence:
          '<0>Ambos jugadores deben tener Números de Tenis Mundial verificados para que se muestre una predicción precisa.</0> <2>Entendiendo la verificación</2>',
      },
      totalWins: 'Total de victorias',
      loginToView: '<0>Iniciar sesión</0> para ver',
    },
    strMatchResults: {
      matchResults: 'resultados de partidos',
      competitions: {
        title: 'Resultados de competición',
        modal: {
          header: 'Competiciones',
        },
      },
      social: {
        title: 'Mis resultados de partidos',
        modal: {
          header: 'Mis Partidos',
        },
      },
      dateRound: 'Fecha',
      players: 'jugadores',
      score: 'puntuación',
      noResults: {
        title: 'No se encontraron resultados',
        info: 'Lo sentimos, no pudimos obtener ningún resultado.',
      },
      openAllResults: 'Abrir todos los resultados',
      closeAllResults: 'Cerrar todos los resultados',
    },
    strCommonCompetitors: {
      commonCompetitors: 'Competidores en común',
      player: 'Jugador',
      winLoss: 'V / D',
      winPercent: '% VICTORIA',
      totals: 'TOTAL',
      noCommonCompetitors: 'Estos jugadores no tienen competidores en común durante este período',
      showMore: 'Mostrar más',
    },
    strRecentOpponents: {
      header: 'Oponentes recientes',
      thisPlayer: 'este jugador',
      sortBy: 'Ordenar por:',
      date: 'Fecha',
      opponent: 'Oponente',
      winLoss: 'V-D',
      w: 'V',
      l: 'D',
      score: 'Puntuación',
      winLossRecord: 'Registro V/D',
    },
    strDates: {
      monthsShort: [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dic',
      ],
      monthsLong: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
      daysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    },
    strMyAccount: {
      myDetails: 'Mis detalles',
      changePassword: 'Cambiar contraseña',
      signInDetails: {
        title: 'Detalles de inicio de sesión',
        subtitle: 'Abajo podrás actualizar tus detalles de inicio de sesión.',
        bodyTitle: 'Actualizar detalles',
      },
      accountUpToDate: 'Por favor mantén actualizados los detalles de tu cuenta.',
      avatar: 'Avatar',
      editAvatar: 'Editar avatar',
      uploadPhotoText: 'Puedes elegir un avatar ITF.',
      tennisId: 'ID de Tenis',
      playerProfile: 'Perfil del jugador',
      infoText: 'Si te gustaría actualizar tus detalles, por favor',
      infoError:
        'Lo sentimos, ocurrió un error al recuperar tus detalles. Por favor actualiza o intenta de nuevo más tarde.',
      contactUs: 'contáctanos',
      playerInfo: 'Información del jugador',
      profileStrength: 'Fortaleza del Perfil',
      strProfileStrength: {
        wtn: 'Obtener tu WTN',
        avatar: 'Agregar un avatar',
        residence: 'Agregar residencia',
        playerInfo: 'Completar información del jugador',
        postMatch: 'Publicar un resultado de partido',
        haveResult: 'Tener un resultado de partido',
      },
      completionPercentage: '{{count}}% completo',
      completeProfile: 'Completar perfil',
      privacyAndConsents: {
        title: 'Privacidad y consentimientos',
        subtitle: 'Elige quién puede verte y gestiona tus preferencias de comunicación.',
        bodyTitle: 'Tus preferencias',
        form: {
          profileVisibility: {
            alert:
              'Para disfrutar completamente tu experiencia del Número de Tenis Mundial establece la visibilidad de tu perfil como "Público". Tu perfil de jugador no será buscable y tu nombre no se mostrará en los resultados de partidos.',
            label: 'Establecer la visibilidad de tu perfil',
            optionPublic: 'Público (recomendado)',
            optionPrivate: 'Privado',
          },
        },
      },
      logout: 'Cerrar sesión',
    },
    strEditProfile: {
      editProfile: 'Editar Perfil',
      profile: 'Perfil',
      playerInfo: 'Información del jugador',
      clubsAssociations: 'Clubes y asociaciones',
      inputFirstName: 'Nombre',
      inputLastName: 'Apellido',
      inputNickName: 'Apodo',
      inputNickNamePlaceholder: 'Ingresa Apodo',
      inputNationality: 'Nacionalidad',
      inputDoB: 'Fecha de nacimiento',
      inputDayPlaceholder: 'DD',
      inputMonthPlaceholder: 'MMM',
      inputYearPlaceholder: 'AAAA',
      inputSex: 'Sexo',
      inputFemale: 'Femenino',
      inputMale: 'Masculino',
      inputGender: 'Género',
      inputResidence: 'País de residencia',
      inputResidencePlaceholder: 'Buscar...',
      inputHeight: 'Altura',
      inputHeightPlaceholder: '75cm - 225cm',
      inputMetric: 'Métrico',
      inputImperial: 'Imperial',
      inputPreferredHand: 'Mano preferida',
      optsPreferredHandRight: 'Derecha',
      optsPreferredHandLeft: 'Izquierda',
      inputBackhand: 'Revés',
      optsBackhandSingle: 'Una mano',
      optsBackhandTwo: 'Dos manos',
      inputFavouriteShot: 'Golpe favorito',
      inputFavouriteShotPlaceholder: 'Por favor elige...',
      optsFavouriteShotForehand: 'Derecha',
      optsFavouriteShotBackhand: 'Revés',
      optsFavouriteShotServe: 'Saque',
      optsFavouriteShotVolley: 'Volea',
      optsFavouriteShotSmash: 'Remate',
      optsFavouriteShotDropShot: 'Dejada',
      dropdownPlaceholder: '-- selecciona una opción --',
      update: 'Actualizar',
    },
    strSelectAvatar: {
      selectAvatar: 'Seleccionar avatar',
      chooseAvatar: 'Elige un avatar',
      chooseStyle: 'Elige un estilo',
      uploadPhoto: 'Subir foto',
      pickItfAvatar: 'elegir avatar ITF',
      cancel: 'CANCELAR',
      setAsMyAvatar: 'Establecer como mi Avatar',
    },
    strUploadImage: {
      fileUploadText: 'Tamaño máximo de archivo de 4 MB. JPG o PNG',
      fileSizeError: {
        1: 'Lo sentimos, la imagen que estás tratando de subir es mayor a 4 MB.',
        2: 'Por favor reduce el tamaño e intenta de nuevo.',
      },
      fileTypeError: {
        1: 'Lo sentimos, el formato de la imagen que estás tratando de subir no está soportado.',
        2: 'Los formatos soportados son JPG y PNG.',
      },
      buttonText: 'Subir archivo',
      uploadFromDevice: 'Subir desde tu dispositivo',
      changePhoto: 'Cambiar foto',
      dragAndDropHere: 'Arrastra y suelta tu imagen aquí',
      dragAndDropBelow: 'Arrastra y suelta tu imagen abajo',
      or: 'o',
      update: 'actualizar',
      remove: 'eliminar',
      uploadAnotherPhoto: 'Subir otra foto',
      dragToReposition: 'Arrastra para reposicionar y redimensionar tu foto',
    },
    strData: {
      noPlayerName: 'Jugador Desconocido',
      unknown: 'Desconocido',
      optOutPlayerName: 'Jugador',
      na: 'N/A',
      pro: 'PRO',
      male: 'Masculino',
      female: 'Femenino',
      unspecified: 'No especificado',
      ellipsis: '...',
      single: 'Una mano',
      double: 'Dos manos',
      left: 'Zurdo',
      right: 'Diestro',
      ambidextrous: 'Ambidiestro',
    },
    strRegister: {
      header: 'Bienvenido',
      subheader: 'Crea tu cuenta',
      commConsentItf:
        'Sí, me gustaría recibir noticias, información y ofertas especiales de la ITF',
      commConsentNa:
        'Sí, me gustaría recibir emails de mi Asociación Nacional con fines de marketing',
      intro:
        'Crea tu cuenta de usuario de ID de Tenis ITF para obtener acceso al <2>Número de Tenis Mundial ITF</2>.',
      introAlreadyCustomer: {
        1: 'Parece que ya tienes una cuenta de usuario de ID de Tenis ITF con uno de los otros servicios en línea de la ITF como IPIN o ITF Academy.',
        2: 'Por favor presiona CONTINUAR para iniciar sesión usando tu email y contraseña de cuenta ITF existente para completar tu registro para el <1>Número de Tenis Mundial ITF</1>.',
      },
      infoBoxOne:
        '¿No eres {{firstName}} {{lastName}}?<1/><2>Haz clic aquí</2> para saber qué hacer a continuación',
      infoBoxTwo: '¿Tus detalles son incorrectos? Si es así, por favor haz clic <2>aquí</2>',
      recaptchaDisclaimer:
        'Este sitio está protegido por reCAPTCHA y se aplican la <2>Política de Privacidad</2> y <6>Términos de Servicio</6> de Google.',
      agreeTermsWelcome:
        'Al crear una cuenta, aceptas la <2>Política de Privacidad ITF</2> y los <6>Términos y Condiciones del Número de Tenis Mundial ITF</6>',
      agreeTermsWelcomeParent:
        'Al crear una cuenta, tu Padre/Tutor acepta la <2>Política de Privacidad ITF</2> y los <6>Términos y Condiciones del Número de Tenis Mundial ITF</6>',
      agreeTermsWelcomeYouAndParent:
        'Al crear una cuenta, tú y/o tu Padre/Tutor aceptan la <2>Política de Privacidad ITF</2> y los <6>Términos y Condiciones del Número de Tenis Mundial ITF</6>',
      agreeTermsActivation:
        'Al activar tu cuenta, aceptas la <2>Política de Privacidad ITF</2> y los <6>Términos y Condiciones del Número de Tenis Mundial ITF</6>',
      invalidResidence: {
        GBR: "Actualmente no podemos registrar jugadores que residen en el Reino Unido. La buena noticia es que aún puedes averiguar tu Número de Tenis Mundial ITF registrándote o iniciando sesión en tu perfil en el <2>sitio web de LTA</2><3/>*Por favor selecciona 'Irlanda' para tu país de residencia si resides en Irlanda del Norte. Esto se debe a la estructura provincial de Tennis Ireland.",
        FRA: "Actualmente no podemos registrar jugadores que residen en Francia. Para más información sobre tenis en Francia por favor haz clic <2>aquí</2>.<4/>Bonjour, a l'heure actuelle l'enregistrement en ligne en France n'est pas disponible. Pour plus d'informations, veuillez visiter le site de la <7>Federation francaise du tennis</7>.",
        USA: "Los jugadores que residen en EE.UU. pueden crear y desbloquear su cuenta del Número de Tenis Mundial haciendo clic en el enlace <1>'CREAR PERFIL WTN'</1> en su <4>perfil USTA</4>",
      },
      whereDidYouHear: {
        NA: 'Asociación Nacional (incluyendo ITF)',
        TENNIS_CLUB: 'Club de Tenis',
        TENNIS_TOURNAMENT: 'Torneo de Tenis',
        WORD_OF_MOUTH: 'Boca a boca',
        SOCIAL_MEDIA: 'Redes sociales',
        SEARCH_ENGINE: 'Motor de búsqueda',
        BLOG_OR_PUBLICATION: 'Blog o publicación',
        OTHER: 'Otro',
      },
      personas: {
        CASUAL_PLAY: 'Juego casualmente con amigos y familia',
        COMPETITIVE_PLAY: 'Juego competitivamente en torneos y ligas',
        INTEREST_ONLY: 'No juego pero tengo interés en el tenis',
        COACH: 'Entreno tenis',
        PARENT_OR_CARER: 'Soy padre/cuidador de un jugador Junior',
        OTHER: 'Otro',
      },
      comingSoon: {
        title: 'El registro estará disponible pronto',
      },
      parentalConsent: {
        fastTrack: {
          title: 'Padre/Tutor',
        },
        infoBox: {
          title: 'Registros menores de 18',
          info: 'Si tienes menos de 18 años debes pedir el consentimiento de tus padres o tutor legal antes de registrarte para una cuenta en worldtennisnumber.com.',
        },
        helpText: 'Por favor proporciona el nombre y dirección de email de tu padre o tutor legal.',
      },
      residenceValidationError:
        'Algo salió mal obteniendo los datos del país de residencia. Por favor intenta de nuevo.',
    },
    strFastTrackRegistration: {
      accountCreated: '¡Tu cuenta ha sido creada!',
      welcome: 'Bienvenido',
      features: {
        one: 'Actividad de partidos',
        two: 'Zona de Juego personalizada',
        three: 'Historial del Número de Tenis Mundial ITF',
      },
      checkDetails: 'Por favor revisa tus detalles abajo para asegurarte de que son correctos',
      residenceTooltip: {
        partOne:
          'Conocer tu país de residencia nos permite apoyar tus consultas y mejorar tu experiencia.',
        partTwo:
          'Si resides en varios países, por favor elige aquel donde juegas torneos de tenis más frecuentemente.',
      },
      residenceInfoQuestion: '¿Qué pasa si resido en varios países?',
    },
    strMessageScreen: {
      backToHome: 'Volver a la página principal',
      pageNotFound: 'Página no encontrada',
      pageNotFoundInfo: 'La página que solicitaste no se puede encontrar',
      pageRestricted: 'Inicio de sesión requerido',
      pageRestrictedInfo: 'Por favor inicia sesión para ver esta página',
      signOutRequired: 'Cierre de sesión requerido',
      signOutRequiredInfo: 'Por favor cierra sesión para ver esta página',
      playerNotFound: 'Jugador no encontrado',
      playerNotFoundInfo:
        'No se pudo encontrar el ID del jugador. El enlace que seguiste puede estar roto, o la página puede haber sido eliminada.',
      ownProfileError: 'Error cargando perfil',
      ownProfileErrorInfo: 'Ocurrió un error al recuperar los detalles de tu perfil',
      ownProfileErrorLink: 'Por favor actualiza o intenta de nuevo más tarde',
      appError: 'Algo salió mal',
      appErrorInfo: 'Ocurrió un error al procesar tu solicitud',
      appErrorLink: 'Por favor actualiza o intenta de nuevo más tarde',
      somethingWrong: 'Algo salió mal',
      somethingWrongInfo:
        'Por favor navega de vuelta a la página principal o selecciona otra página del menú de navegación',
      alreadyRegistered: 'Cuenta ya registrada',
      alreadyRegisteredLink: 'Ir a iniciar sesión',
      activationError: 'Error de activación',
      activationErrorInfo: 'Ocurrió un error al activar tu cuenta',
      activationErrorLink: 'Haz clic aquí para contactarnos',
      activationLoginPrompt: 'Inicio de sesión requerido',
      activationLoginPromptInfo:
        'Por favor inicia sesión con tus credenciales para completar la activación de la cuenta',
      signInLink: 'Ir a iniciar sesión',
      signOutLink: 'Cerrar mi sesión',
      fastTrackError: 'Algo salió mal',
      fastTrackErrorInfo: 'Ocurrió un error al recuperar o actualizar tus detalles',
      fastTrackErrorLink: 'Haz clic aquí para contactarnos',
      recaptchaValidationError: 'Fallo en la validación reCAPTCHA',
      recaptchaValidationErrorLink: 'Actualizar página',
      inviteRequired: 'Invitación requerida',
      inviteRequiredInfo:
        'Lo sentimos, actualmente necesitas tener una invitación para registrarte en el Número de Tenis Mundial ITF',
      inviteRequiredLink: 'Volver a la página principal',
      psqUnableSubmit: "No se puede enviar el cuestionario 'Califica Mi Juego'",
      psqUnableSubmitInfo:
        "No puedes enviar un cuestionario 'Califica Mi Juego' ya que ya tienes un Número de Tenis Mundial ITF",
      psqUnableSubmitLink: 'Volver a mi perfil',
      psqNotEligibleInfo:
        "La función 'Califica Mi Juego' actualmente no está disponible en tu país de residencia",
      psqUnableSubmitMinAge:
        "Necesitas tener al menos {{minAge}} años para enviar un cuestionario 'Califica Mi Juego'",
      psqSubmitError: "Error enviando el cuestionario 'Califica Mi Juego'",
      psqSubmitErrorInfo:
        "Hubo un error al enviar tu cuestionario 'Califica Mi Juego'. Por favor intenta de nuevo más tarde.",
      psqSubmitErrorLink: 'Volver a mi perfil',
      featureNotAvailable: 'Función no disponible',
      featureNotAvailableProAndJuniors:
        'Esta función no está disponible para jugadores con un IPIN junior o profesional activo.',
      errorInfo: {
        intro: 'Mensaje:',
        location: 'Ubicación:',
        rlog: 'RLOG:',
      },
      recaptchaValidationErrorInfo:
        'reCAPTCHA no pudo determinar con certeza que el formulario fue enviado por un humano. Por favor actualiza esta página e intenta de nuevo. Si el problema persiste <2>contáctanos</2>',
      featureNotAvailableReadFaqs:
        '<0>Puede que no seas elegible para esta función. Por favor lee nuestras <2>Preguntas Frecuentes</2>.</0>',
      lockedFeature: {
        logInOrSignUp: '<0><0>Inicia sesión</0> o <2>Regístrate</2> para una cuenta.</0>',
        blurredResults: 'Para ver resultados, necesitarás estar conectado',
        blurredMatchHistory: 'Para ver el historial de partidos, necesitarás estar conectado',
        blurredWtnHistory: 'Para ver el historial, necesitarás estar conectado',
      },
    },
    strAlerts: {
      updatingDetails: 'Actualizando detalles...',
      detailsUpdated: 'Detalles actualizados exitosamente',
      detailsNotUpdated: 'Error actualizando detalles',
      avatarNotUploaded: 'Error subiendo imagen de avatar',
      actionError:
        'Error tratando de realizar la acción solicitada. Por favor intenta de nuevo más tarde.',
      removingPlayerWl: 'Eliminando jugador de lista(s) de seguimiento...',
      playerWlRemoved: 'Jugador eliminado de lista(s) de seguimiento exitosamente',
      errorRemovingPlayerWl: 'Error eliminando jugador de lista(s) de seguimiento',
      addingPlayerWl: 'Agregando jugador a lista(s) de seguimiento...',
      playerWlAdded: 'Jugador agregado a lista(s) de seguimiento exitosamente',
      errorAddingPlayerWl: 'Error agregando jugador a lista(s) de seguimiento',
      managingPlayerWl: {
        success: {
          add: "Agregado a '{{name}}'",
          addPlural: 'Agregado a {{count}} listas de seguimiento',
          remove: "Eliminado de '{{name}}'",
          removePlural: 'Eliminado de {{count}} listas de seguimiento',
          create: "'{{name}}' creado",
          update: "'{{name}}' actualizado",
          updatePlural: '{{count}} listas de seguimiento actualizadas',
        },
        error: {
          add: "Error agregando a '{{name}}'",
          addFull: "<1>No se puede agregar el jugador</1><2/>'{{name}}' está lleno",
          addPlural: 'Error agregando a {{count}} listas de seguimiento',
          addPluralFull:
            '<1>No se puede agregar el jugador</1><2/>{{count}} listas de seguimiento están llenas',
          remove: "Error eliminando de '{{name}}'",
          removePlural: 'Error eliminando de {{count}} listas de seguimiento',
          create: "Error creando '{{name}}'",
          createFull: "Límite de listas de seguimiento alcanzado: No se pudo crear '{{name}}'",
        },
      },
      creatingWl: 'Creando lista de seguimiento...',
      wlCreated: 'Lista de seguimiento creada exitosamente',
      errorCreatingWl: 'Error tratando de crear lista de seguimiento',
      deletingWl: 'Eliminando lista de seguimiento...',
      wlDeleted: 'Lista de seguimiento eliminada exitosamente',
      errorDeletingWl: 'Error tratando de eliminar lista de seguimiento',
      renamingWl: 'Renombrando lista de seguimiento...',
      wlRenamed: 'Lista de seguimiento renombrada exitosamente',
      errorRenamingWl: 'Error tratando de renombrar lista de seguimiento',
      approvingSocialMatch: 'Aceptando tu puntuación...',
      errorApprovingSocialMatch: 'Error aceptando tu puntuación',
      socialMatchApproved: 'Puntuación aceptada exitosamente',
      rejectingSocialMatch: 'Rechazando tu puntuación...',
      errorRejectingSocialMatch: 'Error rechazando tu puntuación',
      socialMatchRejected: 'Puntuación rechazada exitosamente',
      errorSubmittingSocialMatch: 'Error enviando tu puntuación',
      deletingSocialMatch: 'Eliminando tu puntuación...',
      errorDeletingSocialMatch: 'Error eliminando tu puntuación',
      socialMatchDeleted: 'Puntuación eliminada exitosamente',
      socialMatchAlreadyDeleted: 'Parece que este partido ha sido eliminado por el usuario',
      socialMatchAlreadyApproved: 'Parece que este partido ya ha sido aprobado por el usuario',
      copiedToClipboard: '¡Copiado al portapapeles!',
      failedCopyingToClipboard: 'Fallo al copiar al portapapeles',
      errorPlayerSearch: 'Error buscando jugadores',
      csvDownload: {
        success: 'Descarga CSV exitosa',
        error: 'Error en descarga CSV',
      },
    },
    strWatchlists: {
      overview: {
        title: 'Mis listas de seguimiento',
        subtitle: '{{count}}/{{max}} listas de seguimiento creadas',
        panelEmpty: {
          title: 'Aún no hay listas de seguimiento',
          info: 'Busca un jugador y usa el ícono de estrella para agregarlo a una lista de seguimiento.',
          button: 'Comenzar a buscar',
        },
        card: {
          count: '{{count}}/{{max}} jugadores',
        },
        createBtn: 'Crear nueva lista de seguimiento',
      },
      detail: {
        count: '{{count}}/{{max}} jugadores',
        panelEmpty: {
          title: 'Tu lista de seguimiento está vacía',
        },
        addBtn: 'Agregar jugadores',
      },
      addOrManageModal: {
        add: {
          title: 'Agregar a lista de seguimiento',
          watchlistFull: '(lista de seguimiento llena)',
          info: 'Agregar <1>{{name}}</1> a:',
        },
        manage: {
          title: 'Seleccionar una lista de seguimiento',
          info: 'Asignar o eliminar <1>{{name}}</1> a/de:',
        },
        create: {
          label: 'Crear nueva lista de seguimiento',
          charsCount: '{{count}}/{{max}} caracteres',
          limitReached:
            'No puedes crear nuevas listas de seguimiento porque alcanzaste el límite ({{count}}/{{max}}).',
        },
      },
      createModal: {
        title: 'Crear una lista de seguimiento',
        titleFull: 'Límite de listas de seguimiento alcanzado',
        defaultLabel: 'Nombre de lista de seguimiento',
        info: 'Usa listas de seguimiento para guardar jugadores para más tarde.',
        infoFull: 'No puedes crear más listas de seguimiento. Por favor elimina una primero.',
      },
      renameModal: {
        title: 'Renombrar lista de seguimiento',
        info: 'Elige un nombre diferente abajo para renombrar la lista de seguimiento.',
      },
      deleteModal: {
        title: 'Eliminar lista de seguimiento',
        info: 'Elige un nombre diferente abajo para renombrar la lista de seguimiento.',
      },
      common: {
        averageSinglesWtn: 'WTN Promedio de Individuales: {{average}}',
        minSinglesWtn: 'WTN Mín. de Individuales: {{min}}',
        maxSinglesWtn: 'WTN Máx. de Individuales: {{max}}',
      },
      watchlists: 'listas de seguimiento',
      watchlist: 'Lista de seguimiento',
      name: 'Nombre de lista de seguimiento',
      firstName: 'Nombre',
      lastName: 'Apellido',
      save: 'Guardar',
      cancel: 'Cancelar',
      noCancel: 'No, Cancelar',
      yesDelete: 'Sí, Eliminar',
      playerWatchlistsTitle: 'Seleccionar lista(s) de seguimiento',
      defaultWatchlist: 'Mi lista de seguimiento',
      update: 'Actualizar',
      add: 'Agregar',
      delete: 'Eliminar',
      rename: 'Renombrar',
      new: 'Crear nueva',
      players: 'Jugadores',
      gender: 'Género',
      nationality: 'Nacionalidad',
      singles: 'Individuales',
      doubles: 'Dobles',
      noPlayers: 'No hay jugadores en la lista de seguimiento',
      deleteWatchlist: 'Eliminar lista de seguimiento',
      deleteWatchlistAlertStart: '¿Estás seguro de que quieres eliminar permanentemente',
      deleteWatchlistAlertEnd:
        'lista de seguimiento junto con los jugadores en esa lista de seguimiento?',
      deletePlayerAlert:
        '¿Estás seguro de que quieres eliminar el/los jugador(es) seleccionado(s)?',
      limit: 'Se pueden crear un máximo de 5 listas de seguimiento.',
      watchlistOverview: {
        intro: 'Puedes crear hasta <1>{{maxWatchlists}} listas de seguimiento.</1>',
        rulesIntro: 'Cada lista de seguimiento puede tener:',
        rule1: 'Hasta <1>{{maxPlayers}} jugadores</1>',
        rule2: 'Un <1>nombre a tu elección</1>',
        featuresIntro: 'Podrás',
        feature1: 'Agregar jugadores',
        feature2: 'Eliminar jugadores',
        feature3: 'Eliminar listas de seguimiento',
      },
      watchlistDetail: {
        infoText: 'Puedes tener hasta <1>{{maxPlayers}} jugadores</1> por lista de seguimiento.',
      },
      addPlayers: {
        title: 'Agregar jugadores',
        info: '<0>Puedes agregar jugadores a la <1>lista de seguimiento {{name}}.</1></0>',
        label: 'Buscar jugador',
      },
      createWatchlist: {
        title: 'Crear lista de seguimiento',
        infoText:
          'Puedes crear hasta {{maxWatchlists}} y agregar hasta {{maxPlayersForWatchlist}} jugadores a cada una.',
        textUnderInput: 'Máx {{maxChars}} caracteres',
      },
      deleteWatchlistModal: {
        info: "¿Estás seguro de que quieres eliminar permanentemente la lista de seguimiento <1>'{{name}}'</1> junto con los jugadores en esa lista de seguimiento?",
      },
      addToWatchlist: {
        title: 'Agregar a lista de seguimiento',
        infoText: 'Elige a qué listas de seguimiento quieres agregar <2>{{name}}</2>:',
        infoFull1:
          'Ya has alcanzado el número máximo de listas de seguimiento ({{maxWatchlists}}) y todas están llenas ({{maxPlayers}} jugadores cada una).',
        infoFull2: 'No podrás agregar ningún jugador hasta que crees espacio.',
      },
      watchlistModal: {
        createNew: 'Crear nueva lista de seguimiento',
      },
    },
    strPsq: {
      heading: 'Califica Mi Juego',
      introMsg:
        'Completa estas preguntas simples para que podamos crearte un <1>Número de Tenis Mundial ITF</1> hasta que comiences a competir.',
      infoBox:
        'Solo podrás completar esto <1>una vez.</1><2 /><3>No podrás cambiar</3> tus respuestas, así que por favor asegúrate de completarlo correctamente.',
      review: {
        title: 'Revisar',
        infoText: 'Por favor revisa tus respuestas y envía cuando estés listo.',
      },
      modalConfirm: {
        heading: 'Confirmar respuestas',
        infoText:
          'Solo podrás enviar este formulario <1>UNA VEZ</1>.<3></3>Por favor <5>confirma que estás satisfecho con las respuestas</5>.',
      },
      screenCompleted: {
        common: { heading: 'Tu número' },
        public: {
          info1:
            'Tus respuestas han sido usadas para generar un <1>Número de Tenis Mundial</1> que podrás usar hasta que comiences a competir.',
          info2:
            'Tu <1>número de Individuales</1> ha sido establecido como <4>{{wtnSingles}}</4><5/>Tu <7>número de Dobles</7> ha sido establecido como <10>{{wtnDoubles}}</10>',
          info3: 'Reclama tu perfil y comienza:',
          info4:
            '<0><1>Mejorando tu puntuación</1><1>Compara tu puntuación con tus compañeros de club y jugadores alrededor del mundo</1><1>Rastrea cambios en tu puntuación</1><1>Sigue amigos y oponentes y ve sus resultados</1><1>Accede a todos tus resultados en un lugar</1></0>',
          info5:
            'Si tu Asociación Nacional te ha proporcionado un WTN a través de resultados de partidos pasados, esto tendrá precedencia sobre el WTN que acabas de generar.',
          button: 'Reclamar mi perfil',
        },
        registered: {
          info1: 'Gracias por responder nuestras preguntas.',
          info2:
            'Tus respuestas han sido usadas para generar un <1>Número de Tenis Mundial</1> que podrás usar hasta que comiences a competir.',
          info3:
            'Tu <1>número de Individuales</1> ha sido establecido como <4>{{wtnSingles}}</4><5/>Tu <7>número de Dobles</7> ha sido establecido como <10>{{wtnDoubles}}</10>',
          info4: 'Disfruta tu tenis.',
          button: 'Mi página de perfil',
        },
      },
      submitErrorInfo: 'Por favor actualiza o intenta de nuevo más tarde',
      widgetMsg: 'Comienza a competir para obtener tu número',
      widgetText: '',
      widgetLinkText:
        "Hasta que comiences a jugar completa nuestro cuestionario <2>'Califica Mi Juego'</2>",
      q1: { question: '¿En qué tipo de partidos sueles jugar?', intro: 'Juego:' },
      q2: { question: '¿Cómo describirías tu nivel de habilidad en la cancha?', intro: 'Soy:' },
      q3: { question: '¿Eres principalmente un jugador de individuales o de dobles?' },
      q4: { question: 'Por experiencia, ¿con qué frecuencia mantienes tu saque?' },
      q5: {
        question:
          'Pensando en cuando tomaste una raqueta por primera vez, ¿cuántos años has estado jugando tenis?',
      },
      q6: { question: '¿Cuál es tu sexo?' },
      q7: { question: 'Por favor ingresa tu edad' },
      q1a1: {
        review: 'Juego <strong>por diversión</strong> cuando tengo la oportunidad',
        option: '<strong>por diversión</strong> cuando tengo la oportunidad',
      },
      q1a2: {
        review: 'Juego <strong>partidos casuales</strong> con amigos o familia',
        option: '<strong>partidos casuales</strong> con amigos o familia',
      },
      q1a3: {
        review:
          'Juego <strong>partidos oficiales en amateur</strong> torneos, clubes, ligas o equipos universitarios/escolares',
        option:
          '<strong>partidos oficiales en amateur</strong> torneos, clubes, ligas o equipos universitarios/escolares',
      },
      q1a4: {
        review: 'Juego <strong>partidos oficiales a nivel de condado</strong> torneos y ligas',
        option: '<strong>partidos oficiales a nivel de condado</strong> torneos y ligas',
      },
      q1a5: {
        review: 'Juego <strong>partidos oficiales en regional o nacional</strong> torneos o ligas',
        option: '<strong>partidos oficiales en regional o nacional</strong> torneos o ligas',
      },
      q2a1: {
        review:
          'Estoy <strong>empezando</strong> como jugador de tenis, pero me gustaría jugar más',
        option: '<strong>empezando</strong> como jugador de tenis, pero me gustaría jugar más',
      },
      q2a2: {
        review:
          'Aún soy <strong>un principiante</strong> pero he jugado algunos juegos y estoy ganando confianza',
        option:
          '<strong>un principiante</strong> pero he jugado algunos juegos y estoy ganando confianza',
      },
      q2a3: {
        review:
          'Estoy <strong>jugando regularmente</strong> y mejorando cada vez que salgo a la cancha',
        option: '<strong>jugando regularmente</strong> y mejorando cada vez que salgo a la cancha',
      },
      q2a4: {
        review:
          'Soy <strong>un jugador intermedio.</strong> Puedo leer el juego de mi oponente y tengo una amplia selección de golpes',
        option:
          '<strong>un jugador intermedio.</strong> Puedo leer el juego de mi oponente y tengo una amplia selección de golpes',
      },
      q2a5: {
        review:
          'Estoy <strong>compitiendo regularmente en partidos arreglados</strong> y gano bastante seguido',
        option:
          '<strong>compitiendo regularmente en partidos arreglados</strong> y gano bastante seguido',
      },
      q2a6: {
        review:
          'Estoy <strong>compitiendo regularmente en torneos</strong> y generalmente gano los partidos que juego',
        option:
          '<strong>compitiendo regularmente en torneos</strong> y generalmente gano los partidos que juego',
      },
      q2a7: {
        review:
          'Estoy <strong>compitiendo regularmente en competiciones y torneos,</strong> ganando mis partidos cómodamente',
        option:
          '<strong>compitiendo regularmente en competiciones y torneos,</strong> ganando mis partidos cómodamente',
      },
      q2a8: {
        review:
          'Estoy <strong>entrando regularmente en torneos</strong> y siempre soy uno de los mejores jugadores en la cancha',
        option:
          '<strong>entrando regularmente en torneos</strong> y siempre soy uno de los mejores jugadores en la cancha',
      },
      q3a1: {
        review: 'Soy un jugador de <strong>Individuales</strong>',
        option: '<strong>Individuales</strong>',
      },
      q3a2: {
        review: 'Soy un jugador de <strong>Dobles</strong>',
        option: '<strong>Dobles</strong>',
      },
      q4a1: {
        review: '<strong>Rara vez gano</strong> el punto cuando estoy sacando',
        option: '<strong>Rara vez gano</strong> el punto cuando estoy sacando',
      },
      q4a2: {
        review: '<strong>Compito por cada punto</strong> pero a veces me vencen en mi saque',
        option: '<strong>Compito por cada punto</strong> pero a veces me vencen en mi saque',
      },
      q4a3: {
        review: '<strong>Gano casi todos</strong> mis puntos cuando saco',
        option: '<strong>Gano casi todos</strong> mis puntos cuando saco',
      },
      q4a4: { review: 'No estoy muy seguro', option: 'No estoy muy seguro' },
      q5a1: {
        review: 'He estado jugando por <strong>Menos de 1</strong> año',
        option: '<strong>Menos de 1</strong> año',
      },
      q5a2: {
        review: 'He estado jugando por <strong>1 - 2</strong> años',
        option: '<strong>1 - 2</strong> años',
      },
      q5a3: {
        review: 'He estado jugando por <strong>2 - 5</strong> años',
        option: '<strong>2 - 5</strong> años',
      },
      q5a4: {
        review: 'He estado jugando por <strong>5 - 10</strong> años',
        option: '<strong>5 - 10</strong> años',
      },
      q5a5: {
        review: 'He estado jugando por <strong>10 - 20</strong> años',
        option: '<strong>10 - 20</strong> años',
      },
      q5a6: {
        review: 'He estado jugando por <strong>Más de 20</strong> años',
        option: '<strong>Más de 20</strong> años',
      },
      q6a1: { review: 'Soy <strong>masculino</strong>', option: '<strong>Masculino</strong>' },
      q6a2: { review: 'Soy <strong>femenino</strong>', option: '<strong>Femenino</strong>' },
      q7a1: 'Tengo <strong>{{value}}</strong> años',
    },
    strPolicies: {
      heading: 'Políticas de Privacidad y Cookies del Número de Tenis Mundial ITF',
      intro: 'Ve nuestras políticas para',
      under18: 'menores de 18 años',
      over18: 'mayores de 18 años',
      cookiePolicy: 'política de cookies',
    },
    strFilters: {
      genderDefaultLabel: 'Cualquier Género',
      male: 'Masculino',
      female: 'Femenino',
      anyGender: 'Género',
      anyGenderOption: 'Cualquier género',
      nonBinary: 'No Binario',
      anyAgeGroup: 'Grupo de edad',
      ageGroupCompositeDropdownLabel: 'Edad: {{ageGroup}}',
      ageGroupBornInLabel: 'Nacido en {{birthYear}}',
      countries: 'Países',
      yes: 'sí',
      no: 'no',
      filterBy: 'Filtrar por',
      countryDefaultLabel: 'Nacionalidad',
      nationalityCompositeDropdownLabel: 'Nacionalidad: +{{numberSelected}}',
      clearFilter: 'Limpiar filtro',
      countryFilterPlaceholder: 'Escribe para filtrar...',
      wtnRange: 'Rango WTN',
      apply: 'APLICAR FILTRO',
      cancel: 'CANCELAR',
      rangeLabel: 'Puntuación {{range}}',
      rangeLabelSingles: 'Número de individuales',
      rangeLabelDoubles: 'Número de dobles',
      clearFilters: 'Limpiar filtros',
      filters: 'Filtros',
      minRating: 'Puntuación mínima',
      maxRating: 'Puntuación máxima',
      rating: {
        radioAllPlayers: 'Todos los jugadores',
        radioRatingRange: 'Rango de puntuación',
        labelDropdownCombined: 'Puntuación WTN',
        labelRatingType: 'Tipo de puntuación',
        labelConfidenceLevel: 'Nivel de confianza',
        labelGameZone: 'Mi Zona de Juego',
        defaultLabelSingles: 'Número de individuales',
        defaultLabelDoubles: 'Número de dobles',
        radioSingles: 'Individuales',
        radioDoubles: 'Dobles',
        radioConfidenceHigh: 'Alta confianza (verificado)',
        radioConfidenceAll: 'Todos',
        compositeDropdownLabel: '{{appliedLabel}}: {{min}}-{{max}}',
        inputError: 'Los valores permitidos están entre {{max}} y {{min}} con solo un decimal.',
      },
      confidenceModal: {
        title: 'Verificación de Número',
        subtitle:
          'Tu número tiene una marca de verificación, esto se relaciona con el grado de confianza',
        featureConfidenceHigh: {
          title: 'Confiable',
          items: {
            1: 'Tenemos <1>muchos resultados</1> para ti, así que entendemos mejor tu habilidad',
            2: 'Puedes <1>confiar en que tu Número es preciso</1>',
          },
        },
        featureConfidenceLow: {
          title: 'Más datos requeridos',
          items: {
            1: 'Necesitamos <1>resultados más recientes</1> para ti para entender mejor tu habilidad',
            2: 'Tu número puede <1>no ser tan preciso como podría ser</1>',
          },
        },
        ariaLabel: {
          tickHigh: 'Cinta de confianza azul',
          tickLow: 'Cinta de confianza gris',
          exampleNumber: 'Número de ejemplo',
        },
      },
      gameZoneModal: {
        title: 'Zona de Juego',
        register: {
          info: '<0>Esta función está disponible solo para usuarios registrados.</0>',
          button: '<0>registrarse ahora</0>',
        },
        content:
          '<0>Nuestra Zona de Juego identifica un rango de oponentes potenciales cuyos Números están cerca del tuyo en la escala.</0><1><0>La Zona de Juego encontrará oponentes equilibrados donde sea que estés, para asegurar la mejor experiencia posible en la cancha</0><1>Nuestro algoritmo líder en la industria analiza datos de rendimiento de jugadores y millones de resultados de partidos.</1></1><2>No olvides, a medida que tu Número cambie, tu Zona de Juego también cambiará, así que asegúrate de revisar regularmente para encontrar nuevos oponentes para jugar.</2>',
      },
    },
    strProviderLink: {
      content: '<0>Datos suministrados por {{providerName}}. </0>',
      landing: '<0>Ver detalles en el <2>sitio web de {{providerName}}</2>.</0>',
      support: '<0>¿Algo no está bien? <2>Contacta a {{providerName}}</2>.</0>',
    },
  },
}

const languageDetector = new LanguageDetector()
languageDetector.addDetector({
  name: 'customPathDetector',
  lookup() {
    return getCurrentLanguage()
  },
  cacheUserLanguage(lng) {},
})

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'strCommonUI',
    debug: false,
    detection: {
      order: [
        'customPathDetector',
        'navigator',
        'querystring',
        'cookie',
        'localStorage',
        'sessionStorage',
        'htmlTag',
      ],
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
